<template>
    <div>
        <template>
            <div id="breadcrumb-alignment" class="mb-1">
                <div class="d-flex justify-content-start breadcrumb-wrapper">
                    <b-breadcrumb :items="breadCrumb()" />
                </div>
            </div>
        </template>

        <b-card>
            <b-alert v-model="showDismissibleAlert" variant="danger" dismissible class="mb-1">
                <div class="alert-body">
                    {{ error_message }}
                </div>
            </b-alert>

            <b-row>

              <b-col md="12">              
                  <h4 class="card-title float-left">Update Order</h4>            
              </b-col>
          
            </b-row>

            <b-row>
                <b-col md="3">
                  <b-form-group label="Project Site" class="required">
                      <b-form-select v-model="site" @change="siteChange();" :disabled="disabledOptions">
                        <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                        <b-form-select-option :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Order Type" class="required">
                        <b-form-select v-model="order_type" @change="changetype" :disabled="disabledOptions">
                        <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                        <b-form-select-option value="monthly" :disabled="!checkOrderCount">Monthly</b-form-select-option>
                        <b-form-select-option value="adhoc" v-if="$store.getters.currentUser.role != 'supervisor'">Adhoc</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" >
                    <b-form-group label="Date" class="required"> 
                    <b-form-datepicker
                        v-model="date"
                        :date-format-options="{ day: 'numeric', month: 'short', year: 'numeric' }"
                        locale="en"
                        :disabled="$store.getters.currentUser.role != 'admin'"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="3" >
                    <b-form-group label="Order By" class="required">
                    <b-form-input placeholder="3 to 50 characters" v-model="order_by" autocomplete="off" :disabled="disabledOptions"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>

                <b-col md="3">
                     
                    <h5 class="mt-1">Order for a Month : {{ month }}</h5>                               
                </b-col>

                
            </b-row>

        </b-card>
        <b-form @submit="formSubmit">
            <b-card no-body class="mb-1" v-for="(list, i) in orderData" :key="i">
                <div v-if="site != ''">

                    <fieldset class="table-responsive" style="margin-bottom: 0px !important;" :disabled="checkSupplierDisable(list.supplier)">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="7" style="padding-top: 22px; width: 100%;padding-bottom: 0px !important;">
                                        <b-row>
                                            <b-col md="8">
                                                <b-row>
                                                    <b-col md="3" class="mb-2">
                                                        <!-- <b-form-select v-model="list.supplier" @change="updateSupplier(i); flag_data = false" :disabled="disabledOptions"> removed from Issac Feedback-->
                                                            <!-- {{checkSupplierDisable(list.supplier)}} -->
                                                        <b-form-select v-model="list.supplier" @change="updateSupplier(i); flag_data = false">
                                                            <b-form-select-option value="" disabled>Select Supplier</b-form-select-option>
                                                            <b-form-select-option :value="supplier._id" :disabled="supplierDisable(supplier._id) || supplier.status == 'inactive'" v-for="supplier in suppliers" :key="supplier._id + '' + i">{{ supplier.name | capitalize }}</b-form-select-option>
                                                        </b-form-select>
                                                    </b-col>

                                                    <b-col md="3" class="mb-2">
                                                        <b-form-select v-model="list.category" @change="updateCategory(i)">
                                                            <b-form-select-option value="" disabled>Select Category</b-form-select-option>
                                                            <b-form-select-option :value="category._id" v-for="category in list.categories" :key="category._id + '' + i">{{ category.name | capitalize }}</b-form-select-option>
                                                        </b-form-select>
                                                    </b-col>

                                                    <b-col md="3" class="mb-2">
                                                        <b-form-select v-model="list.sub_category">
                                                            <b-form-select-option value="" disabled>Select Sub Category</b-form-select-option>
                                                            <b-form-select-option :value="sub_category._id" v-for="sub_category in list.sub_categories" :key="sub_category._id + '' + i">{{ sub_category.name | capitalize }}</b-form-select-option>
                                                        </b-form-select>
                                                    </b-col>

                                                    <b-col md="3" class="mb-2">
                                                        <b-form-input placeholder="Search Items" v-model="list.filter_items" @input="matchItem(i);" autocomplete="off"/>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="4">
                                                <!-- <b-row> -->
                                                    <!-- <b-col md="4"> -->
                                                        <b-button
                                                            
                                                            variant="success"
                                                            class="order_btns mb-2"
                                                            @click="resetFilter(i); list.filter_items='';"                                            
                                                            >
                                                            Reset
                                                        </b-button>
                                                    <!-- </b-col> -->
                                                    <!-- <b-col md="4"> -->
                                                        <!-- <b-button
                                                            variant="warning"
                                                            class="order_btns mb-2"
                                                            @click="updateSupplierData(i, orderData[i]); flag_data = false;"
                                                            v-if="orderData.length > 0 && orderData[0].data.length > 0"
                                                            >
                                                            Refresh
                                                        </b-button> -->
                                                    <!-- </b-col> -->
                                                    <!-- <b-col md="4"> -->
                                                        <!-- :disabled="disabledOptions" removed from Issac Feedback -->
                                                        <!-- v-if="orderData.length > 0 && orderData[0].data.length > 0 && orderData[i].db_order == false" -->
                                                        <b-button
                                                            
                                                            variant="danger"
                                                            class="mb-2"
                                                            @click="removeData(i); flag_data = true;"
                                                            >
                                                            Remove
                                                        </b-button>
                                                        <!-- :disabled="disabledOptions" removed from Issac Feedback -->
                                                        <!-- <b-button
                                                            
                                                            variant="danger"
                                                            class="mb-2"
                                                            @click="removeDBData(i, orderData[i]); flag_data = true;"
                                                            v-if="orderData.length > 0 && orderData[0].data.length > 0 && orderData[i].db_order == true"
                                                            >
                                                            Remove
                                                        </b-button> -->
                                                    <!-- </b-col> -->
                                                <!-- </b-row> -->
                                            </b-col>
                                            
                                            
                                        </b-row>

                                    </th>
                                    
                                </tr>
                                <tr>
                                    <th scope="col" style="width: 5%;">
                                       {{ '#' }}
                                    </th>
                                    <th scope="col" style="width: 25% !important">
                                        {{ 'Item Name' }}  
                                    </th>
                                    <th scope="col" style="width:14%">
                                        {{ 'Packing' }}
                                    </th>
                                    <th scope="col" style="width:14%">
                                        {{ 'Rate' }}
                                    </th>
                                    <th scope="col" style="width:14%">
                                        {{ 'Qty' }}
                                    </th>
                                    <th scope="col" style="width:14%">
                                        {{ 'Amt' }}
                                    </th>
                                    <th scope="col" style="width:14%">
                                        {{ 'Bal' }}
                                    </th>
                                    

                                </tr>
                            </thead>
                            <tbody v-show="show_all_items">

                                <tr style="height:70px;" v-for="(l, index) in list.data" v-if="(list.data.length > 0) && l.matched == true &&
                                ( (list.category == '' && list.sub_category == '') ||
                                (list.category != '' && list.sub_category == '' && list.category == l.category) ||
                                (list.category != '' && list.sub_category != '' && list.sub_category != 'general'  && list.sub_category == l.sub_category) ||
                                (list.category != '' && list.sub_category != '' && list.sub_category == 'general' && list.category == l.category  && l.sub_category == null))">
                                    <td>

                                        <b-form-checkbox
                                        v-model="l.enabled"
                                        value="yes"
                                        unchecked-value="no"
                                        class="mb-0 mt-0"
                                        @change="updateItemValue(i,index)"
                                        >

                                        </b-form-checkbox>
                                    </td>

                                    <td>

                                        <span class="h6 text-light">

                                            <span class="wordBreak">{{ l.name }}</span>
                                            <b-badge pill variant="warning" class="text-capitalize" v-if="l.most_order == 'yes'">Popular Item</b-badge>

                                        </span>
                                    </td>

                                    <td>
                                        <span>{{ l.packing }}</span>
                                    </td>
                                    <td>
                                        <b-form-input
                                            placeholder=""
                                            v-model="l.unit_price"
                                            autocomplete="off"
                                            @change="calAmount(i, index)"
                                            @keypress="isDouble($event)"
                                             v-if="l.enabled == 'yes' && $store.getters.currentUser.role == 'admin'"
                                        />
                                        <span v-if="l.enabled == 'no' || $store.getters.currentUser.role != 'admin'">{{ l.unit_price | showReadNum }}</span>
                                    </td>

                                    <td>
                                        <b-form-input
                                            :ref="'qty_' + i + '_' + index"
                                            placeholder=""
                                            v-model="l.qty"
                                            type="text"
                                            autocomplete="off"
                                            :state="isQtyInvalid(i, index) ? false : null"
                                            @change="calAmount(i, index)"
                                            @keypress="isNumber($event)"
                                             v-if="l.enabled == 'yes'"
                                        />
                                        <span v-if="l.enabled == 'no'"> {{ '0' }}</span>
                                    </td>

                                    <td>
                                        <span v-if="l.amount != ''">{{l.amount | showReadNum }}</span> 
                                        <span v-else>{{ '$0.00' }}</span>                
                                    </td>
                                    <td>
                                        <b-form-input
                                            placeholder=""
                                            v-model="l.bal"
                                            type="text"
                                            autocomplete="off"
                                            @keypress="isNumber($event)"
                                            v-if="l.enabled == 'yes'"
                                        />
                                        <span v-if="l.enabled == 'no'"> {{ l.bal }}</span>    
                                    </td>
                                    

                                      
                                </tr>
                                <tr v-if="list.data.length == 0">
                                    <td colspan="7" class="text-center">
                                        <span >{{ 'No records found' }}</span>
                                            
                                    </td>
                                </tr>
                            </tbody>

                            
                            <tbody v-show="!show_all_items">

                                <tr style="height:70px;" v-for="(l, index) in list.data" v-if="(list.data.length > 0) && l.matched == true &&
                                ( (list.category == '' && list.sub_category == '') ||
                                (list.category != '' && list.sub_category == '' && list.category == l.category) ||
                                (list.category != '' && list.sub_category != '' && list.sub_category != 'general'  && list.sub_category == l.sub_category) ||
                                (list.category != '' && list.sub_category != '' && list.sub_category == 'general' && list.category == l.category  && l.sub_category == null))">
                                    <td>

                                        <b-form-checkbox
                                        v-model="l.enabled"
                                        value="yes"
                                        unchecked-value="no"
                                        class="mb-0 mt-0"
                                        @change="updateItemValue(i,index)"
                                        >

                                        </b-form-checkbox>
                                    </td>

                                    <td>

                                        <span class="h6 text-light">

                                            <span class="wordBreak">{{ l.name }}</span>
                                            <b-badge pill variant="warning" class="text-capitalize" v-if="l.most_order == 'yes'">Popular Item</b-badge>

                                        </span>
                                    </td>

                                    <td>
                                        <span>{{ l.packing }}</span>
                                    </td>
                                    <td>
                                        <b-form-input
                                            placeholder=""
                                            v-model="l.unit_price"
                                            autocomplete="off"
                                            @change="calAmount(i, index)"
                                            @keypress="isDouble($event)"
                                             v-if="l.enabled == 'yes' && $store.getters.currentUser.role == 'admin'"
                                        />
                                        <span v-if="l.enabled == 'no' || $store.getters.currentUser.role != 'admin'">{{ l.unit_price | showReadNum }}</span>
                                    </td>

                                    <td>
                                        <b-form-input
                                            :ref="'qty_' + i + '_' + index"
                                            placeholder=""
                                            v-model="l.qty"
                                            type="text"
                                            autocomplete="off"
                                            :state="isQtyInvalid(i, index) ? false : null"
                                            @change="calAmount(i, index)"
                                            @keypress="isNumber($event)"
                                             v-if="l.enabled == 'yes'"
                                        />
                                        <span v-if="l.enabled == 'no'"> {{ '0' }}</span>
                                    </td>

                                    <td>
                                        <span v-if="l.amount != ''">{{l.amount | showReadNum }}</span> 
                                        <span v-else>{{ '$0.00' }}</span>                
                                    </td>
                                    <td>
                                        <b-form-input
                                            placeholder=""
                                            v-model="l.bal"
                                            type="text"
                                            autocomplete="off"
                                            @keypress="isNumber($event)"
                                            v-if="l.enabled == 'yes'"
                                        />
                                        <span v-if="l.enabled == 'no'"> {{ l.bal }}</span>    
                                    </td>
                                    

                                      
                                </tr>
                                <tr v-if="list.data.length == 0">
                                    <td colspan="7" class="text-center">
                                        <span >{{ 'No records found' }}</span>
                                            
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                    
                    <div>
                        <hr />
                        <b-row>
                            <b-col md="6">
                                
                                <h5 class="float-left mt-1 mb-0 ml-2" v-if="orderData.length > 0">Sub Total Amount : {{ updateSubPrice(i) | showReadNum }}</h5>
                                
                            </b-col>
                            <b-col md="6">
                            
                        
                            </b-col>  
                        </b-row>
                        <hr>   

                        <b-row>
                            <b-col md="6">
                                
                                <h6 class="float-left mt-1 mb-2 ml-2" v-if="orderData.length > 0 && deliveryDate != null">
                                    <span v-if="(list.delivery_fee_removed && list.delivery_fee_removed == 'yes') || deli_fee_moq[i.toString()] == 0">Delivery Fee : <s>{{ list.delivery_fee | showReadNum }}</s></span>
                                    <span v-else>Delivery Fee : {{ list.delivery_fee | showReadNum }}</span>
                                </h6>
                                <h6 class="float-left mt-1 mb-2 ml-2" v-else-if="orderData.length > 0">
                                    <span v-if="(list.delivery_fee_removed && list.delivery_fee_removed == 'yes') || (list.fee_weiver == 'yes' && (Number(updateSubPrice(i)) >= Number(list.moq)))">Delivery Fee : <s>{{ list.delivery_fee | showReadNum }}</s></span>
                                    <span v-else>Delivery Fee : {{ list.delivery_fee | showReadNum }}</span>
                                </h6>
                            
                            </b-col>
                            <b-col md="6">
                                
                                <h6 class="float-left mt-1 mb-2 ml-2" v-if="orderData.length > 0">Minimum Order Amount : {{ list.moq  | showReadNum }}</h6>
                    
                            </b-col>     
                        </b-row>
                        <b-row v-if="$store.getters.currentUser.role == 'admin'">
                            <b-col md="12">
                                <b-form-checkbox class="float-left custom-control-primary mb-2 mt-1 ml-2" v-if="orderData.length > 0" style="font-weight: 500;" value="yes" unchecked-value="no" v-model="orderData[i]['delivery_fee_removed']" >Remove Delivery Fee</b-form-checkbox>
                            </b-col>   
                        </b-row>

                        

                    </div>
                    
                </div>
            </b-card>
            
            <b-card class="mt-1" v-if="orderData.length > 0 && orderData[0].data.length > 0">
                <b-row class="mb-2">
                    <b-col md="6">
                        <!-- <h5>Total Amount - $ {{ orderTotalAmount | showReadNum }}</h5> -->
                    </b-col>
                    <b-col md="6">
                        
                        <!-- :disabled="disabledOptions" removed from Issac Feedback -->
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="warning"
                            class="mr-1 float-right"
                            @click="addMore(); flag_data = false;"
                            v-if="site != ''"
                            >
                            Add More
                        </b-button>
                        
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">

                        <b-form-group
                        label="Special Requisition (Please Indicate)"
                        class=""
                        >
                        <b-form-textarea
                            placeholder="upto 500 characters"
                            rows="3"
                            v-model="special_requisition"
                        />
                        </b-form-group>


                    </b-col>
                    
                </b-row>
            </b-card>

            <b-card class="mt-1" v-if="(orderData.length > 0 && orderData[0].data.length > 0) && (!['supervisor', 'crew'].includes($store.getters.currentUser.role))">    
                <h3 class="text-center mb-1"> Delivery Information </h3>

                <!-- <b-row v-if="multiple_delivery_option == 'yes'"> -->
                <b-row>
                    
                    <b-col cols="12">
                        <!-- <b-form-checkbox v-model="enable_multiple_supplier_delivery_site" value="yes" unchecked-value="no" class="mb-0 mt-0" :disabled="disabledOptions" @input="updateSite();">
                            Deliver to Other Project Site
                        </b-form-checkbox> -->
                        <!-- <b-form-checkbox v-model="enable_multiple_supplier_delivery_site" value="yes" unchecked-value="no" class="mb-0 mt-0" @input="updateSite();">
                            Deliver to Other Project Site
                        </b-form-checkbox> -->
                        <b-form-radio v-model="enable_multiple_supplier_delivery_site" value="yes" class="mb-0 mt-0" @change="updateSiteSelfCollect()" style="display: inline-block; margin-right: 15px;">
                            Deliver to Project Site
                        </b-form-radio>
                        <b-form-radio v-model="enable_multiple_supplier_delivery_site" value="no" class="mb-0 mt-0" @change="updateSite(); deliveryDate = null;" style="display: inline-block;">
                            Self Collect
                        </b-form-radio>
                    </b-col>

                    <b-col md="12" class="mt-2" v-if="$store.getters.currentUser.role == 'admin' && enable_multiple_supplier_delivery_site == 'yes'">
                        <b-form-group label="Delivery Date" class="required"> 
                            <b-row class="p-0 m-0">
                                <b-col cols="4" class="p-0 m-0">
                                    <b-form-datepicker
                                        ref="deliveryDateInput"
                                        v-model="deliveryDate"
                                        :date-format-options="{ day: 'numeric', month: 'short', year: 'numeric' }"
                                        locale="en"
                                        :state="invalidDeliveryDate ? false : null"
                                        :disabled="$store.getters.currentUser.role != 'admin'"
                                    />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>

                    <b-col md="4" sm="6" v-for="(el, ind) in orderData" :key="ind" class="mt-2" v-if="enable_multiple_supplier_delivery_site == 'no' && orderData.length > 0 && orderData[0].supplier.length > 0"  style="">
                        
                        <b-card v-if="el.supplier && el.supplier.length > 0" no-body class="card-developer-meetup h-100 p-1 mb-0" style="border: 1px solid #f4f4f4;">
                            <div v-for="item in suppliers" :key="item._id">

                                <div v-if="item._id == el.supplier">

                                    <div class="">
                                        <div class="mb-1">
                                            <b-row>
                                                <b-col cols="12" class="pb-1">
                                                    Collect at - {{item.name}}
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>

                                    <b-media no-body>
                                        <b-media-aside class="mr-1">
                                            <b-avatar rounded variant="light-danger" size="20">
                                                <feather-icon icon="MapPinIcon" size="15"/>
                                            </b-avatar>
                                        </b-media-aside>
                                        <b-media-body>
                                            <h6 class="mb-0 wordBreak">{{ item.address | capitalize }}</h6>
                                        </b-media-body>
                                    </b-media>

                                    <b-media no-body>
                                        <b-media-aside class="mr-1">
                                            <b-avatar rounded variant="light-warning" size="20">
                                                <feather-icon icon="UserIcon" size="15"/>
                                            </b-avatar>
                                        </b-media-aside>
                                        <b-media-body>
                                            <h6 class="mb-0" v-if="item.attn.length > 0"> {{item.attn | capitalize}}</h6>
                                            <h6 class="mb-0" v-else> N/A </h6>
                                        </b-media-body>
                                    </b-media>

                                    <b-media no-body>
                                        <b-media-aside class="mr-1">
                                            <b-avatar rounded variant="light-success" size="20">
                                                <feather-icon icon="PhoneIcon" size="15"/>
                                            </b-avatar>
                                        </b-media-aside>
                                        <b-media-body>
                                            <h6 class="mb-0" v-if="item.phone_number"> {{ showNumberFormat(item.phone_number, item.country) }} </h6>
                                            <h6 class="mb-0" v-else> N/A </h6>
                                        </b-media-body>
                                    </b-media>

                                </div>
                                
                            </div>
                            
                        </b-card>
                        <b-card v-else no-body class="card-developer-meetup h-100 p-1 mb-0 text-center" style="border: 1px solid #f4f4f4;">
                            <h5 class="text-secondary">Please Select Supplier</h5>
                        </b-card>
                    </b-col>

                    <!-- <b-col md="4" sm="6" v-for="(item, ind) in deliveryData" :key="ind" class="" v-if="enable_multiple_supplier_delivery_site == 'no'" class="mt-2" style="opacity: 0.5; pointer-events: none;">
                      <b-card no-body class="card-developer-meetup h-100 p-1 mb-0" style="border: 1px solid #f4f4f4;">


                              <div class="">

                                  <div class="mb-1">
                                      <b-row>
                                          <b-col cols="12" class="pb-1">
                                              Deliver to -
                                          </b-col>
                                      </b-row>
                                      <b-row class="px-0">
                                          <b-col cols="9" class="">                                                

                                              <b-form-select v-model="item.site" @change="dlSiteChange($event, ind)">
                                                  <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                                                  <b-form-select-option :disabled="siteDisable(site._id)" :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                                              </b-form-select>
                                          </b-col>
                                          <b-col cols="3" class="pl-0 ml-0">

                                                  <div @click="item._showDetails = item._showDetails ? false : true;" class="float-left" style="padding-top: 7px;">
                                                      <feather-icon icon="EyeOffIcon" class="text-warning" v-if="item._showDetails"/>
                                                      <feather-icon icon="EyeIcon" class="text-warning" v-else/>
                                                  </div>

                                              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="float-right" @click="removeDeliveryItem(ind)" v-if="multiple_delivery_option == 'yes'" :disabled="disabledOptions && item._from_db">
                                                  <feather-icon icon="XIcon" class="" />
                                              </b-button>
                                          </b-col>
                                      </b-row>
                                  </div>
                              </div>
                              
                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-danger" size="20">
                                          <feather-icon icon="MapPinIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0">{{ item.address | capitalize }}</h6>
                                  </b-media-body>
                              </b-media>
                              
                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-warning" size="20">
                                          <feather-icon icon="UserIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0" v-if="item.user"> {{item.user.full_name | capitalize}} ({{item.user.role | removeUnderCapitalize}}) </h6>
                                      <h6 class="mb-0" v-else> N/A </h6>
                                  </b-media-body>
                              </b-media>
                              
                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-success" size="20">
                                          <feather-icon icon="PhoneIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0" v-if="item.user"> {{ showNumberFormat(item.user.phone_number, item.country) }} </h6>
                                      <h6 class="mb-0" v-else> N/A </h6>
                                  </b-media-body>
                              </b-media>


                      </b-card>
                  </b-col> -->
                  <b-col md="4" sm="6" v-for="(item, ind) in multiDeliveryData" :key="ind" v-if="enable_multiple_supplier_delivery_site == 'yes'" class="mt-2">
                      <b-card no-body class="card-developer-meetup h-100 p-1 mb-0" style="border: 1px solid #f4f4f4;">
                          <!-- <b-card-body> -->
                              <!-- {{ item }} -->
                              <div class="mb-1">
                                  <!-- <div v-if="multiple_delivery_option == 'yes'" class="mb-1"> -->
                                      <b-row>
                                          <b-col cols="11" class="pb-1">
                                              Supplier Name : {{ item.supplier_name }}
                                          </b-col>
                                          <b-col cols="1" class="pl-0 ml-0 pb-1">
                                              <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="warning" > -->
                                                  <div @click="item._showDetails = item._showDetails ? false : true;" class="float-left">
                                                      <feather-icon icon="EyeOffIcon" class="text-warning" v-if="item._showDetails"/>
                                                      <feather-icon icon="EyeIcon" class="text-warning" v-else/>
                                                  </div>
                                              <!-- </b-button> -->
                                          </b-col>
                                      </b-row>
                                      <b-row class="px-0">
                                          <b-col cols="12" class="">
                                            <b-form-radio v-model="item.site_source" value="assigned" class="mb-0 mt-0" @change="onDeliverySiteSourceChange(ind)">
                                                Assigned Project Sites
                                            </b-form-radio>
                                            <b-form-select :ref="'assignedSite_' + ind" v-model="item.site" @change="msdSiteChange(ind)" :disabled="disabledOptions && item._from_db || item.site_source != 'assigned'" :state="isInvalidDeliverySite(ind) && item.site_source == 'assigned' ? false : null" class="mb-1 mt-1">
                                                <b-form-select-option value="" disabled>Select</b-form-select-option>
                                                <!-- <b-form-select-option :disabled="siteDisableMSD(site._id)" :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option> -->
                                                <b-form-select-option :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                                            </b-form-select>

                                            <b-form-radio v-model="item.site_source" value="other_area" class="mb-0 mt-0" @change="onDeliverySiteSourceChange(ind)" :disabled="!deliveryAreaContext">
                                                Other project sites in Area
                                            </b-form-radio>
                                            <small v-if="!deliveryAreaContext" class="text-muted d-block">This site has no configured cluster/area.</small>
                                            <template v-if="item.site_source == 'other_area'">
                                                <b-form-select :ref="'clusterSelect_' + ind" v-model="item.other_area_cluster" @change="loadClusterSites(ind)" :state="isInvalidDeliverySite(ind) && !item.other_area_cluster ? false : null" class="mb-1 mt-1">
                                                    <b-form-select-option value="" disabled>Select a cluster</b-form-select-option>
                                                    <b-form-select-option :value="c._id" v-for="c in deliveryAreaClusters" :key="c._id">{{ c.name | capitalize }}</b-form-select-option>
                                                </b-form-select>
                                                <b-form-select :ref="'otherAreaSite_' + ind" v-model="item.site" @change="msdSiteChange(ind)" :state="isInvalidDeliverySite(ind) && item.other_area_cluster ? false : null" v-if="item.other_area_cluster">
                                                    <b-form-select-option value="" disabled>Select a project site</b-form-select-option>
                                                    <b-form-select-option :value="s._id" v-for="s in item.other_area_sites" :key="s._id">{{ s.site_name | capitalize }}</b-form-select-option>
                                                    <b-form-select-option value="" disabled v-if="item.other_area_sites.length == 0">No other sites in this cluster</b-form-select-option>
                                                </b-form-select>
                                            </template>
                                          </b-col>
                                      </b-row>
                                              <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="float-right" @click="removeDeliveryItem(ind)" v-if="multiple_delivery_option == 'yes'" :disabled="disabledOptions && item._from_db">
                                                  <feather-icon icon="XIcon" class="" />
                                              </b-button> -->
                                  <!-- </div> -->
                              </div>

                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-danger" size="20">
                                          <feather-icon icon="MapPinIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0">{{ item.address | capitalize }}</h6>
                                  </b-media-body>
                              </b-media>

                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-warning" size="20">
                                          <feather-icon icon="UserIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0" v-if="item.user"> {{item.user.full_name | capitalize}} ({{item.user.role | removeUnderCapitalize}}) </h6>
                                      <h6 class="mb-0" v-else> N/A </h6>
                                  </b-media-body>
                              </b-media>
                              
                              <b-media no-body v-if="!item._showDetails">
                                  <b-media-aside class="mr-1">
                                      <b-avatar rounded variant="light-success" size="20">
                                          <feather-icon icon="PhoneIcon" size="15"/>
                                      </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                      <h6 class="mb-0" v-if="item.user"> {{ showNumberFormat(item.user.phone_number, item.country) }} </h6>
                                      <h6 class="mb-0" v-else> N/A </h6>
                                  </b-media-body>
                              </b-media>

                          <!-- </b-card-body> -->
                      </b-card>
                    </b-col>
                </b-row>

                <!-- <b-row v-else>
                    <b-col cols="4" v-for="(item, ind) in deliveryData" :key="ind" class="mb-2">
                        <b-card no-body class="card-developer-meetup h-100 p-1 mb-0" style="border: 1px solid #f4f4f4;">


                                <div class="mb-1">                                          
                                    
                                    <b-row class="px-0">
                                        <b-col cols="11" class="">                                                
                                            <b-form-select v-model="item.site" @change="dlSiteChange($event, ind)" :disabled="disabledOptions || item._from_db">
                                                <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                                                <b-form-select-option :disabled="siteDisable(site._id)" :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                        <b-col cols="1" class="pl-0 ml-0">
                                                <div @click="item._showDetails = item._showDetails ? false : true;" class="float-right" style="padding-top: 7px;">
                                                    <feather-icon icon="EyeOffIcon" class="text-warning" v-if="item._showDetails"/>
                                                    <feather-icon icon="EyeIcon" class="text-warning" v-else/>
                                                </div>
                                        </b-col>
                                    </b-row>

                                </div>
                                
                                <b-media no-body v-if="!item._showDetails">
                                    <b-media-aside class="mr-1">
                                        <b-avatar rounded variant="light-danger" size="20">
                                            <feather-icon icon="MapPinIcon" size="15"/>
                                        </b-avatar>
                                    </b-media-aside>
                                    <b-media-body>
                                        <h6 class="mb-0">{{ item.address | capitalize }}</h6>
                                    </b-media-body>
                                </b-media>
                                
                                <b-media no-body v-if="!item._showDetails">
                                    <b-media-aside class="mr-1">
                                        <b-avatar rounded variant="light-warning" size="20">
                                            <feather-icon icon="UserIcon" size="15"/>
                                        </b-avatar>
                                    </b-media-aside>
                                    <b-media-body>
                                        <h6 class="mb-0" v-if="item.user"> {{item.user.full_name | capitalize}} ({{item.user.role | removeUnderCapitalize}}) </h6>
                                        <h6 class="mb-0" v-else> N/A </h6>
                                    </b-media-body>
                                </b-media>
                                
                                <b-media no-body v-if="!item._showDetails">
                                    <b-media-aside class="mr-1">
                                        <b-avatar rounded variant="light-success" size="20">
                                            <feather-icon icon="PhoneIcon" size="15"/>
                                        </b-avatar>
                                    </b-media-aside>
                                    <b-media-body>
                                        <h6 class="mb-0" v-if="item.user"> {{ showNumberFormat(item.user.phone_number, item.country) }} </h6>
                                        <h6 class="mb-0" v-else> N/A </h6>
                                    </b-media-body>
                                </b-media>


                        </b-card>
                    </b-col>
                </b-row> -->
                
                <!-- <b-row v-if="multiple_delivery_option == 'yes'">
                    
                    <b-table
                        responsive
                        show-empty
                        ref = "refdeliveryListTable"
                        class = "position-relative reverse-padding"
                        primary-key = "id"
                        empty-text = "No records found"
                        :fields = "tableColumns2"
                        :items = "deliveryData"
                        v-if="site != ''"
                    >

                        <template #cell(s_no)="items">
                            
                            <p>{{ items.index + 1 }}</p>         
                        </template>

                        <template #cell(site)="items">
                            <div v-if="multiple_delivery_option == 'yes'">

                                <b-form-select v-model="items.item.site" @change="dlSiteChange($event,items.index)" :disabled="disabledOptions">
                                    <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                                    <b-form-select-option :value="site._id" v-for="site in sites" :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                                </b-form-select>

                            </div>
                            <div v-else>
                                {{ items.item.site_name }}
                            </div>
                            
                        </template>

                        <template #cell(address)="items">
                            
                            <span>{{ items.item.address | capitalize }}</span>
                            
                        </template>

                        <template #cell(action)="items">
                                
                            <b-button
                        
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="danger"
                                class="mr-1 mb-1 mt-1 float-right"
                                @click="removeDeliveryItem(items.index)"
                                v-if="multiple_delivery_option == 'yes'"
                                :disabled="disabledOptions"
                                >
                                X
                            </b-button>

                        </template>

                        <template #row-details="items">
                                <div class="p-1 px-2 mb-1">
                                    <b-row>
                                    
                                        <b-col cols="12" xl="12"  v-if="items.item.user != null">
                                            <table class="mt-2 mt-xl-0 w-100">
                                                <tr class="mb-1">
                                                    <th class="pb-50" style="width: 25%">
                                                        <div class="d-flex align-items-center">
                            
                                                        <div class="ml-1">
                                                            <h6 class="mb-0 mediumFonts">
                                                            {{ items.item.user.role | removeUnderCapitalize }} Name 
                                                            </h6>
                                
                                                        </div>
                                                        </div>
                                                    </th>
                                                    <td class="pb-50 mediumFonts" style="width: 25%;padding-top: 8px;">
                                                        {{ items.item.user.full_name | capitalize }}
                                                    </td>

                                                    <th class="pb-50" style="width: 25%">
                                                            <div class="d-flex align-items-center">
                            
                                                            <div class="ml-1">
                                                                <h6 class="mb-0 mediumFonts">
                                                                Contact Number 
                                                                </h6>
                                
                                                            </div>
                                                            </div>
                                                        </th>
                                                        <td class="pb-50 mediumFonts" style="width: 25%;padding-top: 8px;">
                                                            {{ showNumberFormat(items.item.user.phone_number, items.item.country) }}
                                                        </td>
                                            
                                            
                                                </tr>


                                            </table>
                                        </b-col>

                                        <b-col cols="12" xl="12" v-if="items.item.user == null">
                                            <table class="mt-2 mt-xl-0 w-100">
                                                    <tr class="mb-1">
                                                        <th class="pb-50" style="width: 100%">
                                                            <div class="text-center align-items-center">
                            
                                                                <div class="ml-1">
                                                                    <h6 class="mb-0">
                                                                    Contact person details not available
                                                                    </h6>
                                    
                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>


                                                </table>
                                        </b-col>

                                    </b-row>
                                </div>
                            </template>
                            

                    </b-table>
                </b-row>
                <b-row v-else>
                    <b-table
                        responsive
                        show-empty
                        ref = "refdeliveryListTable"
                        class = "position-relative reverse-padding"
                        primary-key = "id"
                        empty-text = "No records found"
                        :fields = "tableColumns3"
                        :items = "deliveryData"
                        v-if="site != ''"
                    >
                        <template #cell(site)="items">
                            <b-form-select v-model="items.item.site" @change="dlSiteChange($event, items.index)" :disabled="disabledOptions">
                                <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                                <b-form-select-option :value="site._id" v-for="site in sites"  :key="site._id">{{ site.site_name | capitalize }}</b-form-select-option>
                            </b-form-select>
                        
                        </template>

                        <template #cell(address)="items">
                        
                            <span>{{ items.item.address | capitalize }}</span>
                        
                        </template>

                        <template #row-details="items">
                            <div class="p-1 px-2 mb-1">
                                <b-row>
                                    

                                    <b-col cols="12" xl="12"  v-if="items.item.user != null">
                                        <table class="mt-2 mt-xl-0 w-100">
                                            <tr class="mb-1">
                                                <th class="pb-50" style="width: 25%">
                                                    <div class="d-flex align-items-center">
                            
                                                    <div class="ml-1">
                                                        <h6 class="mb-0 mediumFonts">
                                                        {{ items.item.user.role | removeUnderCapitalize }} Name 
                                                        </h6>
                                
                                                    </div>
                                                    </div>
                                                </th>
                                                <td class="pb-50 mediumFonts" style="width: 25%;padding-top: 8px;">
                                                    {{ items.item.user.full_name | capitalize }}
                                                </td>

                                                <th class="pb-50" style="width: 25%">
                                                        <div class="d-flex align-items-center">
                            
                                                        <div class="ml-1">
                                                            <h6 class="mb-0 mediumFonts">
                                                            Contact Number 
                                                            </h6>
                                
                                                        </div>
                                                        </div>
                                                    </th>
                                                    <td class="pb-50 mediumFonts" style="width: 25%;padding-top: 8px;">
                                                        {{ showNumberFormat(items.item.user.phone_number, items.item.country) }}
                                                    </td>
                                            
                                            
                                            </tr>


                                        </table>
                                    </b-col>

                                    <b-col cols="12" xl="12" v-if="items.item.user == null">
                                        <table class="mt-2 mt-xl-0 w-100">
                                                <tr class="mb-1">
                                                    <th class="pb-50" style="width: 100%">
                                                        <div class="text-center align-items-center">
                            
                                                            <div class="ml-1">
                                                                <h6 class="mb-0">
                                                                Contact person details not available 
                                                                </h6>
                                    
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>


                                            </table>
                                    </b-col>

                                    </b-row>
                            </div>
                        </template>

                    
                    </b-table>
                    
                </b-row> -->
                
                <!-- <b-row v-if="multiple_delivery_option == 'yes'">
                    
                    <b-col md="12">
                    
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="warning"
                            class="mr-1 float-right"
                            @click="addDLMore"
                            :disabled="sites.length == deliveryData.length"
                        >

                            Add More
                        </b-button>

                    </b-col>
                </b-row> -->

            </b-card>   

            <b-card class="mt-1" v-if="(orderData.length > 0 && orderData[0].data.length > 0) && (!['supervisor', 'crew'].includes($store.getters.currentUser.role))">
                <b-row class="mb-0">
                    <b-col md="12">
                        <h3 class="text-center mb-1">Order Summary</h3>
                        <div class="table-responsive" style="margin-bottom: 0px !important;">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Supplier</th>
                                        <th scope="col" class="text-center">Sub Total</th>
                                        <th scope="col" class="text-center">Delivery Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(list, j) in orderData" :key="j">
                                        <td>{{list.supplier_name}}</td>
                                        <td class="text-center">
                                            {{ updateSubPrice(j) | showReadNum }}
                                        </td>
                                        <td class="text-center" v-if="deliveryDate != null">
                                            <span v-if="(list.delivery_fee_removed && list.delivery_fee_removed == 'yes') || deli_fee_moq[j.toString()] == 0">$0.00</span>
                                            <span v-else>
                                                <span v-if="enable_multiple_supplier_delivery_site == 'no'">$0.00</span>
                                                <span v-else>{{ list.delivery_fee | showReadNum }}</span>
                                            </span>
                                        </td>
                                        <td class="text-center" v-else>
                                            <span v-if="(list.delivery_fee_removed && list.delivery_fee_removed == 'yes') || (list.fee_weiver == 'yes' && (Number(updateSubPrice(j)) >= Number(list.moq)))">$0.00</span>
                                            <span v-else>
                                                <span v-if="enable_multiple_supplier_delivery_site == 'no'">$0.00</span>
                                                <span v-else>{{ list.delivery_fee | showReadNum }}</span>
                                            </span>
                                        </td>
                                    </tr>                                    
                                </tbody>
                                <thead>
                                    <tr>
                                        <th scope="col"><span>Total Amount</span></th>
                                        <th scope="col" class="text-center"><span>{{ viewSubTotal() | showReadNum }}</span></th>
                                        <th scope="col" class="text-center" v-if="deliveryDate == null"><span>{{ viewDeliveryTotal() | showReadNum }}</span></th>
                                        <th scope="col" class="text-center" v-else><span>{{ viewDeliveryTotal2() | showReadNum }}</span></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><span>Grand Total Amount</span></th>
                                        <th scope="col" class="text-center" colspan="2"><span>{{ orderTotalAmount | showReadNum }}</span></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><span :class="budget_class">Budget</span></th>
                                        <th scope="col" class="text-center" colspan="2"><span :class="budget_class">{{ selectedSiteBudget | showReadNum }}</span></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                    </b-col>
                </b-row>
                <hr class="mt-1">
                <b-row class="mb-0">
                    <b-col md="12">
                        <span><strong>Note :</strong> The delivery fee will be waived off during check out based on ordered amount.</span>
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="mt-1" v-if="orderData.length > 0 && orderData[0].data.length > 0">    
            
                <b-row>

                    <b-col cols="12" class="mb-2 mt-2">
                        
                    <div class="pb-2">
                        <b-form-group label="Signature" class="required"  style="font-size:20px;color:white;text-align:center" />
                        <center>
                            <div @click="openSignature('supervisor')" v-if="signature.image == null">
                            <!--<template #aside>-->
                                <b-avatar ref="supervisorS" :src="doc_icon" variant="light-info" size="200px" rounded />
                            <!--</template>-->
                            </div>

                            <div class="d-flex flex-wrap">
                                <input ref="supervisorSInput" type="file" class="d-none" @input="supervisorImageUpload" >
                            </div>

                            <img :src="signature.image" width="200px" class="rounded" height="180" v-if="signature.image != null" style="background: #ffffff">
                        </center>

                        <center>
                            <b-button variant="danger" class="mt-1 ml-2" v-if="signature.image != null" @click="removeSign('supervisor')" :disabled="disabledOptions">
                                <feather-icon icon="XIcon" />
                            </b-button>
                        </center>
                    </div>

                    </b-col>
                
                </b-row>
            
                <b-row>
                    <b-col>

                        <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        class = "mr-1"
                        variant="outline-secondary"
                        @click="goBack()"
                        >
                        Cancel
                        </b-button>

                        <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="danger"
                        class="mr-1"
                        v-if="id != null && typeof $route.params.id == 'undefined'"
                        @click="discardItem(id)"
                        >
                        Discard Draft
                        </b-button>

                        <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-1"
                        type="submit"
                        @click="status = 'draft'" v-if="typeof $route.params.id == 'undefined'"
                        >
                        {{ id == null ? 'Save as Draft' : 'Update Draft' }}
                        </b-button>



                        <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="mr-1"
                        type="submit"
                        @click="status = 'completed'"
                        >
                        Update
                        </b-button>

                        <!-- <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-1"
                        v-if="typeof $route.params.id != 'undefined' && ledit == false"
                        @click="openSignature('approver')"
                        >
                        {{ typeof $route.params.id == 'undefined' ? 'Submit' : 'Approve' }}
                        </b-button> -->



                        </b-col>
                </b-row>

            </b-card>
        </b-form>

        <b-modal
            id="signatureModel"
            ref="signatureModel"
            centered
            title="Signature"
            no-close-on-backdrop
            hide-footer
            @hide="hideSignature"
            @show="hideSignature"
          >
      
          <div v-if="show_default == true">
            <b-row>

              <b-col md="11" style="background: #ffffff; height:300px; vertical-align: middle;margin-left: 4%;margin-right:2%">
                <center>
                  <img :src="tempSign.image" width="240px" height="200px" style="background: #ffffff; border-radius: 4px;margin-top: 11%">
                </center>

              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="typeof $route.params.id != 'undefined'">
          
              <b-col md="12">
                <date-picker v-model="approve_signature_time" 
                  format="DD MMM YYYY HH:mm" 
                  type="datetime"
                  placeholder="Select"
                  valueType="format"
                  :clearable=false
                  :confirm=true
                  lang="en"
                  :class="$store.state.appConfig.layout.skin == 'dark' ? 'darkDatePicker' : 'lightDatePicker'"
                  :disabled="$store.getters.currentUser.role == 'supervisor' || $store.getters.currentUser.role == 'operation_manager' || $store.getters.currentUser.role == 'admin' ? false : true"
                  :disabled-date="disabledDate"
                  ></date-picker>


              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="typeof $route.params.id != 'undefined'">
          
              <b-col md="12">
                <b-form-group
                    label="Remarks"
                    class=""
                  >
                    <b-form-textarea
                      placeholder=""
                      rows="3"
                      v-model="approve_remark"
                    />
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-2">

              <b-col md="6">

                  <b-button
                      variant="secondary"
                      class="mt-0 w-100"
                      @click="show_default = false"
                    >
                    <span class="text-nowrap">Add New Signature</span>
                  </b-button>
                </b-col>

                <b-col md="6">
                  <b-button
                      variant="warning"
                      class="mt-0 float-right w-100"
                      @click="saveDefault()"
                    >
                    <span class="text-nowrap">Submit</span>
                  </b-button>
                </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-row>
              <b-col md="12">
                <VueSignaturePad
                  id="signature"
                  width="100%"
                  height="300px"
                  ref="signaturePad"
                  :options="{ onBegin: () => { $refs.signaturePad.resizeCanvas() }, penColor: '#000000', minWidth: 3, maxWidth: 3 }"
                />

              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="typeof $route.params.id != 'undefined'">
          
              <b-col md="12">
                <date-picker v-model="approve_signature_time" 
                  format="DD MMM YYYY HH:mm" 
                  type="datetime"
                  placeholder="Select"
                  valueType="format"
                  :clearable=false
                  :confirm=true
                  lang="en"
                  :class="$store.state.appConfig.layout.skin == 'dark' ? 'darkDatePicker' : 'lightDatePicker'"
                  :disabled="$store.getters.currentUser.role == 'supervisor' || $store.getters.currentUser.role == 'operation_manager' || $store.getters.currentUser.role == 'admin' ? false : true"
                  :disabled-date="disabledDate"
                  ></date-picker>


              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="typeof $route.params.id != 'undefined'">
          
              <b-col md="12">
                <b-form-group
                    label="Remarks"
                    class=""
                  >
                    <b-form-textarea
                      placeholder=""
                      rows="3"
                      v-model="approve_remark"
                    />
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-2">

              <b-col md="3" v-if="typeof $route.params.id == 'undefined'">
                <b-button
                    variant="primary"
                    class="mt-0 w-100"
                    @click="uploadSign()"
                  >
                  <span class="text-nowrap">Upload</span>
                </b-button>
              </b-col>

              <b-col :md="typeof $route.params.id != 'undefined' ? '4' : '3'">

                  <b-button
                      variant="secondary"
                      class="mt-0 w-100"
                      v-if="having_default == true"
                      @click="show_default = true"
                    >
                    <span class="text-nowrap">Default</span>
                  </b-button>
                </b-col>


              <b-col :md="typeof $route.params.id != 'undefined' ? '4' : '3'">

                  <b-button
                      variant="danger"
                      class="mt-0 w-100"
                      @click="clearSignature"
                    >
                    <span class="text-nowrap">Clear</span>
                  </b-button>
                </b-col>

                <b-col :md="typeof $route.params.id != 'undefined' ? '4' : '3'">
                  <b-button
                      variant="warning"
                      class="mt-0 w-100"
                      @click="saveSignature"
                    >
                    <span class="text-nowrap">Submit</span>
                  </b-button>
                </b-col>
            </b-row>
          </div>
        </b-modal>

    </div>
</template>

<script>
import {
    BCard, BButton, BAvatar, BRow, BCol, BAlert, BTable, BMedia, BForm, BFormTextarea, BModal, BBadge, BCardText, BFormInput, BFormGroup, BFormSelect, 
    BFormSelectOption, BFormCheckbox, BFormDatepicker, BBreadcrumb,VBTooltip,
    BCardBody, BCardTitle, BMediaAside, BMediaBody, BFormRadio
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import { GET_API, POST_API } from "../../../store/actions.type"
import 'viewerjs/dist/viewer.css'
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
var moment = require('moment-timezone');
import Bus from "../../../event-bus";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Completed from '../defect_request/Completed.vue'

export default {
    
    components: {
        BCard, BButton, BRow, BCol, BAvatar, BAlert, BTable, BMedia, BForm, BFormTextarea, BModal, BBadge, BCardText, BFormInput, BFormGroup, BFormSelect, BFormSelectOption, 
        Datepicker, BFormCheckbox, BFormRadio, flatPickr, vSelect, BFormDatepicker, BBreadcrumb, DatePicker,
        BCardBody, BCardTitle, BMediaAside, BMediaBody
    },
    computed: {
        selectedSiteBudget() {
            const s = this.sites.find(item => item._id === this.site);
            return s ? s.budget : 'N/A';
        },
        // Pure total-amount calculation, split out of the old updatePrice() so it can be
        // read (for the budget confirm dialog, etc) without re-triggering the "over budget"
        // toast/Swal.close() side effects on every unrelated re-render.
        orderTotalAmount() {
            var amount = 0;

            if (this.deliveryDate == null) {
                this.orderData.forEach(item => {
                    item.data.forEach(t => {
                        amount = parseFloat(amount) + parseFloat(t.amount == '' ? 0 : t.amount);
                    })

                    if (!(item.fee_weiver == 'yes' && amount >= Number(item.moq)) && (!item.delivery_fee_removed || item.delivery_fee_removed=='no')) {
                        if (this.enable_multiple_supplier_delivery_site == 'no') {
                            amount = parseFloat(amount);
                        } else {
                            amount = parseFloat(amount) + parseFloat(item.delivery_fee == '' ? 0 : item.delivery_fee);
                        }
                    }
                })
            } else {
                this.orderData.forEach((item, i) => {
                    item.data.forEach(t => {
                        amount = parseFloat(amount) + parseFloat(t.amount == '' ? 0 : t.amount);
                    })

                    if (this.deli_fee_moq[i.toString()] != 0 && (!item.delivery_fee_removed || item.delivery_fee_removed=='no')) {
                        if (this.enable_multiple_supplier_delivery_site == 'no') {
                            amount = parseFloat(amount);
                        } else {
                            amount = parseFloat(amount) + parseFloat(item.delivery_fee == '' ? 0 : item.delivery_fee);
                        }
                    }
                })
            }

            return amount;
        },
        budget_class() {
            return this.orderTotalAmount > this.selectedSiteBudget ? 'text-danger' : 'text-success';
        }
    },
    data() {
        return {
            original_suppliers: [],
            checkOrderCount: false,
            orderCount: 0,
            date: moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
            deliveryDate: null,
            id: null,
            site: '',
            order_type:'',
            order_by: this.$store.getters.currentUser.full_name,
            sites: [],
            status: 'draft',
            signature: { image: null, name: '', default: 'no' },
            showDismissibleAlert: false,
            error_message: '',
            invalidQtyKey: null,
            invalidDeliveryDate: false,
            invalidDeliverySiteIndex: null,
            doc_icon: require('@/assets/images/doc.png'),
            orderData: [],
            deliveryData:[],
            tempSign: {
                image: null,
                name: '',
            },
            show_default: false,
            having_default: false,
            supervisorSign: {
                image: null,
                name: '',
                type: 'supervisor',
                default: 'no'
            },
            approve_signature_time: null,
            approve_remark: '',
            
            tableColumns2 : [
                { key: 's_no', label: 'SNo', sortable: false, thStyle: { width: '5%' } },
                
                { key: 'site', label: 'Project Site', sortable: false, thStyle: { width: '40%' } },
                { key: 'address', label: 'Address', sortable: false, thStyle: { width: '40%' } },
                { key: 'action', label: '', sortable: false, thStyle: { width: '15%' } },
            ],

            tableColumns3: [
                
                { key: 'site', label: 'Project Site', sortable: false, thStyle: { width: '50%' } },
                { key: 'address', label: 'Address', sortable: false, thStyle: { width: '50%' } },
                
            ],
            
            suppliers:[],
            month: moment().tz('Asia/Singapore').format('MMMM'),
            //months:[],
            special_requisition:'',
            multiple_delivery_option:'no',
            ledit: false,
            disabledOptions:false,
            debounceTimeout: null,

            flag_data: false,
            enable_multiple_supplier_delivery_site: 'no',
            multiDeliveryData: [],
            role: this.$store.getters.currentUser.role,
            show_all_items: true,

            // "Deliver to other project site (same area)" - resolved once from
            // `this.site` (the order's own project site), shared by every row in
            // multiDeliveryData. null = no cluster/area configured for this site.
            deliveryAreaContext: null,
            deliveryAreaClusters: [],
            // Site docs fetched via /delivery-cluster-sites, accumulated across
            // rows so msdSiteChange() can resolve them (they aren't in `sites`).
            extraSites: [],

            validator_status: null,
            original_status: 'draft',
            deli_fee_moq: {},
        }
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    watch: {
        orderData: {
            handler(newVal, oldVal) {
                // Update this.multiDeliveryData based on order key
                if(this.flag_data == false){
                    newVal.forEach(orderItem => {
                        const existingIndex = this.multiDeliveryData.findIndex(item => item.order === orderItem.order);
                        if (existingIndex === -1) {
                            this.multiDeliveryData.push({
                                order: orderItem.order,
                                supplier_name: orderItem.supplier_name,
                                supplier_id: orderItem.supplier_id,
                                site: '',
                                site_name: '',
                                address: '',
                                lat: '',
                                long: '',
                                supervisors: [],
                                operational_managers: [],
                                country: null,
                                _showDetails: false,
                                site_source: 'assigned',
                                other_area_cluster: '',
                                other_area_sites: [],
                                _from_db: false
                            });
                        } else {
                            // Update existing data if needed
                            this.multiDeliveryData[existingIndex].order = orderItem.order;
                            this.multiDeliveryData[existingIndex].supplier_name = orderItem.supplier_name;
                            this.multiDeliveryData[existingIndex].supplier_id = orderItem.supplier_id;
                            // Update other properties if needed
                        }
                    });
    
                    // Ensure the number of records in this.multiDeliveryData matches orderData
                    if (newVal.length !== this.multiDeliveryData.length) {
                        this.multiDeliveryData = newVal.map(item => ({
                            order: item.order,
                            supplier_name: item.supplier_name,
                            supplier_id: item.supplier_id,
                            site: '',
                            site_name: '',
                            address: '',
                            lat: '',
                            long: '',
                            supervisors: [],
                            operational_managers: [],
                            country: null,
                            _showDetails: false,
                            site_source: 'assigned',
                            other_area_cluster: '',
                            other_area_sites: [],
                            _from_db: false
                        }));
                    }
    
                    // Remove data from this.multiDeliveryData if it is removed from orderData
                    const removedOrders = oldVal.filter(item => !newVal.includes(item));
                    removedOrders.forEach(order => {
                        const index = this.multiDeliveryData.findIndex(item => item.order === order.order);
                        if (index !== -1) {
                            this.multiDeliveryData.splice(index, 1);
                        }
                    });
                }
            },
            deep: true
        },
        
        deliveryDate(newVal, oldVal){
            this.invalidDeliveryDate = false;

            this.orderData.forEach((item, index)=>{

                if (this.deliveryDate != null) {
                    this.checkMoq(this.updateSubPrice(index), index, item);
                }
            })
        },

        // Only fires when the total actually changes (unlike the old updatePrice(),
        // which ran - and re-fired the toast / Swal.close() - on every render, even
        // ones triggered by an unrelated confirm dialog during submit).
        orderTotalAmount: {
            immediate: true,
            handler(newVal) {
                if (newVal > this.selectedSiteBudget) {
                    this.customToast('error', 'Total Amount Exceeding Allocated Budget! Please Review Order.');
                } else {
                    Swal.close();
                }
            }
        }
    },

    methods: {
        checkSupplierDisable(id) {
            for (let i = 0; i < this.suppliers.length; i++) {
                const s = this.suppliers[i];
                if (s._id == id) {
                    return s.status === 'inactive';
                }
            }
            // If id not found, do not disable
            return false;
        },
        updateSite(){
            this.multiDeliveryData = [];
            var site = this.sites.find(item => item._id == this.site);
            // console.log('+++++++', site);
            this.orderData.forEach((orderItem, ind) => {
                if(ind == 0){
                    this.multiDeliveryData.push({
                        order: orderItem.order,
                        supplier_name: orderItem.supplier_name,
                        supplier_id: orderItem.supplier_id,
                        site_name: site.site_name,
                        site: site._id,
                        address: site.address,
                        lat: site.lat,
                        long: site.long,
                        supervisors: [],
                        operational_managers: [],
                        country: null,
                        _showDetails: false,
                        site_source: 'assigned',
                        other_area_cluster: '',
                        other_area_sites: [],
                        _from_db: false
                    });
                    this.msdSiteChange(0);
                } else {
                    this.multiDeliveryData.push({
                        order: orderItem.order,
                        supplier_name: orderItem.supplier_name,
                        supplier_id: orderItem.supplier_id,
                        site: '',
                        site_name: '',
                        address: '',
                        lat: '',
                        long: '',
                        supervisors: [],
                        operational_managers: [],
                        country: null,
                        _showDetails: false,
                        site_source: 'assigned',
                        other_area_cluster: '',
                        other_area_sites: [],
                        _from_db: false
                    });
                }
            });
        },
        updateSiteSelfCollect(){
            this.multiDeliveryData = [];
            var site = this.sites.find(item => item._id == this.site);
            this.orderData.forEach((orderItem, ind) => {
                    this.multiDeliveryData.push({
                        order: orderItem.order,
                        supplier_name: orderItem.supplier_name,
                        supplier_id: orderItem.supplier_id,
                        site_name: site.site_name,
                        site: site._id,
                        address: site.address,
                        lat: site.lat,
                        long: site.long,
                        supervisors: [],
                        operational_managers: [],
                        country: null,
                        _showDetails: false,
                        site_source: 'assigned',
                        other_area_cluster: '',
                        other_area_sites: [],
                        _from_db: false
                    });
                    this.msdSiteChange(ind);
            });
        },
        msdSiteChange(i){
            // Site may be an "other area" site (not in the om_sites-filtered
            // `sites` list) - fall back to extraSites, populated as those get
            // fetched via loadClusterSites().
            var site = this.sites.find(item => item._id == this.multiDeliveryData[i].site)
                || this.extraSites.find(item => item._id == this.multiDeliveryData[i].site);

            if (!site) {
                return;
            }

            if (this.invalidDeliverySiteIndex === i) {
                this.invalidDeliverySiteIndex = null;
            }

            this.multiDeliveryData[i].site_name  = site.site_name;
            this.multiDeliveryData[i].site       = site._id;
            this.multiDeliveryData[i].address    = site.address;
            this.multiDeliveryData[i].lat        = site.lat;
            this.multiDeliveryData[i].long       = site.long;
            
            this.multiDeliveryData[i].country = site.country;

            return this.$store.dispatch(POST_API, {
                data: {
                    site: site._id,
                },
                api: '/api/site-area-user-info'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;

                    if (data.length > 0 && data[0].user) {
                        this.$set(this.multiDeliveryData[i], 'user', data[0].user);
                    } else {
                        this.$set(this.multiDeliveryData[i], 'user', null);
                    }
                    return this.multiDeliveryData;
                }
            });
        }, 
        siteDisableMSD(id) {
            var site_ids = [];
            for (var i = 0; i < this.multiDeliveryData.length; i++) {
                site_ids.push(this.multiDeliveryData[i].site);
            }


            if (site_ids.indexOf(id) >= 0) {
                return true;
            } else {
                return false;
            }

        },
        siteDisableMSD(id) {
            var site_ids = [];
            for (var i = 0; i < this.multiDeliveryData.length; i++) {
                site_ids.push(this.multiDeliveryData[i].site);
            }

            if (site_ids.indexOf(id) >= 0) {
                return true;
            } else {
                return false;
            }

        },
        matchItem(j){
            // console.log('++++++++',  this.orderData[j]);

            clearTimeout(this.debounceTimeout);

            this.debounceTimeout = setTimeout(() => {
                for (let i = 0; i < this.orderData[j].data.length; i++) {
                    if (this.orderData[j].data[i].name.toLowerCase().includes(this.orderData[j].filter_items.toLowerCase())) {
                        this.orderData[j].data[i].matched = true;
                    } else {
                        this.orderData[j].data[i].matched = false;
                    }
                }
            }, 50); // Adjust the delay as needed (e.g., 300 milliseconds)

            
            /* if(key != undefined && key.trim() != ''){
                item = item.toLowerCase();
                key = key.toLowerCase();
    
                return item.includes(key);

            } else {return true} */

        },
        siteChange(){
            this.site != '' ? localStorage.setItem('routeCFCheck', 'yes') : localStorage.setItem('routeCFCheck', 'no');

            this.order_type = '',
            this.order_by = this.$store.getters.currentUser.full_name;

            this.orderData = [];

            if (this.site != '') {
                this.allSuppliers();

                if(this.order_type != ''){
                    this.getData().then(() => {
                        this.dlSiteChange(this.site, 0);
                    });
                }
            }
            this.checkMonthlyReportCount();
            this.loadDeliveryAreaContext();
        },
        // "Deliver to other project site (same area)" - resolves the cluster/area
        // for `this.site` (the order's own project site) once, and the clusters
        // in that area. Shared by every row in multiDeliveryData. Safe to call
        // repeatedly (e.g. re-fires on every site change).
        loadDeliveryAreaContext(){
            this.deliveryAreaContext = null;
            this.deliveryAreaClusters = [];

            if (this.site == '') {
                return Promise.resolve();
            }

            return this.$store.dispatch(POST_API, {
                data: {
                    site_id: this.site,
                },
                api: '/api/delivery-site-context'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    return;
                }

                var context = this.$store.getters.getResults.data;
                this.deliveryAreaContext = context;

                if (context) {
                    return this.$store.dispatch(POST_API, {
                        data: {
                            area_id: context.area_id,
                        },
                        api: '/api/delivery-area-clusters'
                    })
                    .then(() => {
                        if (!this.$store.getters.containsErrors) {
                            this.deliveryAreaClusters = this.$store.getters.getResults.data;
                        }
                    });
                }
            });
        },
        // Called when a row's "other area" cluster dropdown changes. Fetches the
        // eligible (already deduped against om_sites) sites for that cluster and
        // accumulates their full docs into extraSites so msdSiteChange() can
        // resolve them the same way it resolves a normal assigned site.
        loadClusterSites(ind){
            this.$set(this.multiDeliveryData[ind], 'other_area_sites', []);

            if (!this.multiDeliveryData[ind].other_area_cluster) {
                return Promise.resolve();
            }

            return this.$store.dispatch(POST_API, {
                data: {
                    cluster_id: this.multiDeliveryData[ind].other_area_cluster,
                },
                api: '/api/delivery-cluster-sites'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    return;
                }

                var siteList = this.$store.getters.getResults.data;
                this.$set(this.multiDeliveryData[ind], 'other_area_sites', siteList);

                siteList.forEach(site => {
                    if (!this.extraSites.find(item => item._id == site._id)) {
                        this.extraSites.push(site);
                    }
                });
            });
        },
        // Fired when a row's assigned/other-area radio changes.
        onDeliverySiteSourceChange(ind){
            this.$set(this.multiDeliveryData[ind], 'other_area_cluster', '');
            this.$set(this.multiDeliveryData[ind], 'other_area_sites', []);

            if (this.multiDeliveryData[ind].site_source == 'assigned') {
                // Back to "Assigned Project Sites" - default is always the
                // order's own project site, same as a freshly-added row.
                this.multiDeliveryData[ind].site = this.site;
                this.msdSiteChange(ind);
            } else {
                // Switching to "other area" - clear so a stale assigned site
                // doesn't get silently submitted as the other-area pick.
                this.multiDeliveryData[ind].site = '';
                this.multiDeliveryData[ind].site_name = '';
                this.multiDeliveryData[ind].address = '';
            }
        },
        useDefault() {

            return this.$store.dispatch(POST_API, {
                data: {
                    id: this.$store.getters.currentUser._id
                },
                api: '/api/get-default-signature'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;

                    if (data == null || data.default_signature == null) {
                        this.having_default = false;
                    } else {
                        this.tempSign = {
                            image: data.default_signature,
                            name: 'signature.png',
                        }

                        this.having_default = true;
                    }
                }
            });
        },
        allSites() {
            var api = this.$route.params.id ? '/api/all-inventory-sites' : '/api/all-inventory-sites-2';
            
            return this.$store.dispatch(POST_API, {
                data: {
                    role: this.$store.getters.currentUser.role,
                    //om_sites:this.$store.getters.currentUser.om_sites,
                },
                api: api
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;

                    this.sites = data;

                    if (this.sites.length == 1 && typeof this.$route.params.id == 'undefined') {
                        this.site = this.sites[0]._id;
                        this.siteChange();
                    }

                    // allSites() and getFormDetails() run concurrently in mounted()
                    // for edit mode - whichever resolves second performs the
                    // assigned/other-area classification once `sites` is ready.
                    if (this.multiDeliveryData.length > 0) {
                        this.hydrateDeliveryRowSources();
                    }

                    return this.sites;
                }
            });
        },
        getData() {
            localStorage.setItem('routeCFCheck', 'no');
            return this.$store.dispatch(POST_API, {
                data: {
                    site: this.site != '' ? this.site : null,
                    date: this.date,
                    month:this.month,
                    order_type:this.order_type
                },
                api: '/api/inventory-order-site-data'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;
                    this.id = data.id;
                    // this.orderData = data.orderData;
                    this.orderData = data.orderData.map(obj => ({
                        ...obj,
                        data: obj.data.map(dataObj => ({ ...dataObj, matched: true }))
                    }));

                    this.signature = data.signature;
                    this.multiple_delivery_option = data.delivery_option;
                    this.special_requisition = data.special_requisition;
                    this.deliveryData = data.deliveryData;

                    this.validator_status = data.level_user_status;
                    
                    // const temp_site = this.sites.find(item => item._id == this.site);
                    
                    // this.deliveryData[0]
                    
                    // this.deliveryData[0] = {
                    //     site: temp_site._id,
                    //     site_name: temp_site.site_name,
                    //     address: temp_site.address,
                    //     lat: temp_site.lat,
                    //     long: temp_site.long,
                    //     user: null,
                    //     country: temp_site.country,
                    //     _showDetails: false,
                    //     _from_db: false
                    // }

                    this.flag_data = true;
                    this.original_status = data.status;

                    this.enable_multiple_supplier_delivery_site = data.enable_multiple_supplier_delivery_site;
                    this.multiDeliveryData = data.multiDeliveryData;
                    this.hydrateDeliveryRowSources();

                    return this.orderData;
                }
            });
        },
        // A row loaded from a saved order may already have a `site` that isn't
        // in the user's current om_sites (assignment changed since, or an admin
        // set it originally). Detect that and mark it as "other area" so the
        // cascade renders it correctly instead of showing a blank dropdown.
        hydrateDeliveryRowSources(){
            // `sites` (om_sites list) loads separately via allSites() and may not
            // have resolved yet - skip rather than misclassify every row as
            // "other area" while it's still empty.
            if (this.sites.length == 0) {
                return;
            }

            this.multiDeliveryData.forEach((item, ind) => {
                // Rows loaded from a saved order (via getData()/getFormDetails())
                // are raw DB documents and never had these frontend-only fields -
                // Vue 2 doesn't track a plain assignment for a key that didn't
                // already exist on the object, so these must go through $set
                // (same reason the existing code $sets `user` a few lines up).
                if (!('other_area_cluster' in item)) {
                    this.$set(item, 'other_area_cluster', '');
                }
                if (!('other_area_sites' in item)) {
                    this.$set(item, 'other_area_sites', []);
                }

                if (!item.site) {
                    this.$set(item, 'site_source', 'assigned');
                    return;
                }

                var isAssigned = this.sites.some(s => s._id == item.site);
                this.$set(item, 'site_source', isAssigned ? 'assigned' : 'other_area');

                if (!isAssigned) {
                    this.hydrateOtherAreaRow(ind);
                }
            });
        },
        // Resolves the cluster (and its area's cluster list) for a row's own
        // site, then loads that cluster's sites so the row's existing selection
        // shows up correctly in the "other area" dropdowns.
        hydrateOtherAreaRow(ind){
            var siteId = this.multiDeliveryData[ind].site;

            return this.$store.dispatch(POST_API, {
                data: {
                    site_id: siteId,
                },
                api: '/api/delivery-site-context'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    return;
                }

                var context = this.$store.getters.getResults.data;
                if (!context) {
                    return;
                }

                this.$set(this.multiDeliveryData[ind], 'other_area_cluster', context.cluster_id);

                return this.$store.dispatch(POST_API, {
                    data: {
                        cluster_id: context.cluster_id,
                    },
                    api: '/api/delivery-cluster-sites'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        return;
                    }

                    var siteList = this.$store.getters.getResults.data;
                    // The row's own site is guaranteed eligible/deduped-in since
                    // it's already selected and not in om_sites; include it even
                    // if the endpoint's dedup happened to exclude it for any reason.
                    if (!siteList.find(s => s._id == siteId)) {
                        var fallback = this.extraSites.find(s => s._id == siteId);
                        if (fallback) {
                            siteList = siteList.concat([fallback]);
                        }
                    }

                    this.$set(this.multiDeliveryData[ind], 'other_area_sites', siteList);

                    siteList.forEach(site => {
                        if (!this.extraSites.find(item => item._id == site._id)) {
                            this.extraSites.push(site);
                        }
                    });
                });
            });
        },
        allSuppliers() {
            return this.$store.dispatch(POST_API, {
                data: {
                    role: this.$store.getters.currentUser.role,
                    item_exist:true,
                    site: this.site,
                    suppliers_in_order: this.original_suppliers,
                    //om_sites:this.$store.getters.currentUser.om_sites,
                },
                api: '/api/all-suppliers-for-update'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;

                    this.suppliers = data;
                    return this.suppliers;
                }
            });
        },
        addMore() {
            var order = 0;

            if (this.orderData.length > 0) {
                var lastIndex = this.orderData.length - 1;
                order = this.orderData[lastIndex].order + 1;
            }

            var obj = {
                supplier: '',
                supplier_name: '',
                category: '',
                
                categories: [],
                sub_category: '',
               
                sub_categories: [],
                data: [],
                order: order,
                db_order: false,
                delivery_fee: '',
                moq: '',
            };

            this.orderData.push(obj);
        },
        removeData(index) {
            this.orderData.splice(index, 1);
            if (this.orderData.length == 0) {
                this.addMore();
            }

            this.multiDeliveryData.splice(index, 1);
            if (this.multiDeliveryData.length == 0) {
                this.multiDeliveryData.push({
                    order: '',
                    supplier_name: '',
                    supplier_id: '',
                    site: '',
                    site_name: '',
                    address: '',
                    lat: '',
                    long: '',
                    supervisors: [],
                    operational_managers: [],
                    country: null,
                    _showDetails: false,
                    site_source: 'assigned',
                    other_area_cluster: '',
                    other_area_sites: [],
                    _from_db: false
                });
            }
        },
        breadCrumb() {
            var item = [{
                to: { name: 'client-dashboard' },
                text: 'Dashboard',
            }, {
                to: null,
                text: 'Inventory'
            }, {
                to: { name: 'inventory-order' },
                text: 'Overview',
            }, {
                to: null,
                text: 'Update Order',
            }];
            return item;  
            },
        supervisorImageUpload(event) {
            var input = event.target;
            var files = event.target.files

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                var image = input.files[0];

                if (image.type != 'image/png' && image.type != 'image/jpeg' && image.type != 'image/jpg') {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Please upload .jpg, .jpeg, .jpg images only',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    this.$refs.supervisorSInput.value = null;

                } else if (image.size > 2097152) {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Maximum 2 MB files allowed to be upload.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.$refs.supervisorSInput.value = null;
                } else {
                    reader.onload = (e) => {
                        this.signature.image = e.target.result;
                        this.signature.name = image.name;
                        this.signature.default = 'no';
                    }
                }
            }
        },
        removeSign(sign) {
            this.signature.image = null;
            this.signature.name = '';
            this.signature.default = 'no';
        },
        uploadSign() {

            this.$refs['supervisorSInput'].click();
            this.$refs['signatureModel'].hide();

        },
        openSignature(type) {
            if(this.special_requisition.length > 0 && this.$route.params.id){
                this.customAlert('', 'There is Special Requisition. Please Acknowledge.', 'info');
            } else {
                this.approve_signature_time = moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY HH:mm');
    
                if (this.openedSignModel == null) {
    
                    if (this.having_default == true) {
                        this.show_default = true;
                    } else {
                        this.show_default = false;
                    }
    
                    this.$refs['signatureModel'].show();
                    this.openedSignModel = type;
                }
            }
        },
        hideSignature() {
            this.openedSignModel = null;
        },
        clearSignature() {
            this.$refs.signaturePad.clearSignature();
        },
        saveSignature() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

            if (isEmpty) {

                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Signature is required',
                    showConfirmButton: false,
                    timer: 1500
                })

            } else {
                if (this.openedSignModel == 'supervisor') {

                    this.signature.image = data;
                    this.signature.name = 'signature.png';
                    this.signature.type = 'supervisor';
                    this.signature.default = 'no';
                    this.$refs['signatureModel'].hide();
                } else {
                    this.supervisorSign.image = data;
                    this.supervisorSign.name = 'signature.png';
                    this.supervisorSign.type = 'supervisor';
                    this.supervisorSign.default = 'no';
                    this.status = 'approved';
                    this.actualForm();
                }
            }
        },
        saveDefault() {

            if (this.openedSignModel == 'supervisor') {
                this.signature = {
                    image: this.tempSign.image,
                    name: 'signature.png',
                    default: 'yes'
                }
            } else {

                this.supervisorSign = {
                    image: this.tempSign.image,
                    name: 'signature.png',
                    default: 'yes',
                    type: 'supervisor'
                }
                this.status = 'approved';
                this.actualForm();

            }

            this.$refs['signatureModel'].hide();
        },
        async updateSupplier(index){

            this.orderData[0].supplier != '' ? localStorage.setItem('routeCFCheck', 'yes') : localStorage.setItem('routeCFCheck', 'no');

            if(this.orderData[index].supplier != ''){
                try {
                    const response = await this.$store.dispatch(POST_API, {
                        data: { id: this.orderData[index].supplier },
                        api: '/api/supplier-detail'
                    });

                    const supplier = response && response.data ? response.data : null;

                    if (supplier) {
                        this.orderData[index].supplier_name = supplier.name || '';
                        this.orderData[index].delivery_fee = supplier.delivery_fee || '';
                        this.orderData[index].moq = supplier.moq || '';
                    } else {
                        this.orderData[index].supplier_name = '';
                        this.orderData[index].delivery_fee = '';
                        this.orderData[index].moq = '';
                    }
                } catch (e) {
                    try {
                        await this.allSuppliers();
                    } catch (refreshError) {
                        // keep the current supplier values if the refresh request fails
                    }

                    var fsupp = this.suppliers.find(item => {
                        return item._id == this.orderData[index].supplier || item._id?.toString() == this.orderData[index].supplier?.toString();
                    });
                    this.orderData[index].supplier_name = fsupp != null ? fsupp.name : '';
                    this.orderData[index].delivery_fee = fsupp != null ? fsupp.delivery_fee : '';
                    this.orderData[index].moq = fsupp != null ? fsupp.moq : '';
                }
            }else{
               this.orderData[index].supplier_name = ''; 
               this.orderData[index].delivery_fee = '';
               this.orderData[index].moq = '';
            }

            this.orderData[index].category = '';
            this.orderData[index].categories = [];
            this.orderData[index].sub_category = '';
            this.orderData[index].sub_categories = [];
            this.orderData[index].filter_items = '';
            this.orderData[index].data =[];

            this.getAllSuppliersItem(this.orderData[index].supplier,index);

            this.getCategories(index);

            if(index == 0){
                this.updateSite();
            } else {
                this.updateSite2(index);
            }

            this.msdSiteChange(index);

        },
        updateSite2(index){
            var site = this.sites.find(item => item._id == this.site);
            // console.log('+++++++', site);
            var orderItem = this.orderData[index];

            this.multiDeliveryData[index] = {
                order: orderItem.order,
                supplier_name: orderItem.supplier_name,
                supplier_id: orderItem.supplier_id,
                site_name: site.site_name,
                site: site._id,
                address: site.address,
                lat: site.lat,
                long: site.long,
                supervisors: [],
                operational_managers: [],
                country: null,
                _showDetails: false,
                site_source: 'assigned',
                other_area_cluster: '',
                other_area_sites: [],
                _from_db: false
            };
            // this.msdSiteChange(0);
        },
        updateCategory(index) {
            
            // if (this.orderData[index].category != '') {
            //     var fsupp = this.orderData[index].categories.find(item => { return item._id == this.orderData[index].category });
            //     this.orderData[index].category_name = fsupp != null ? fsupp.name : '';
            // } else {
            //     this.orderData[index].category_name = '';
            // }

            this.orderData[index].sub_category = '';
            this.orderData[index].sub_categories = [];
            
            this.getSubCategories(index);

        },
        
        getCategories(index) {
            return this.$store.dispatch(POST_API, {
                data: {
                    supplier: this.orderData[index].supplier != '' ? this.orderData[index].supplier : null,
                    site:this.site,
                    item_exist:true,
                },
                api: '/api/all-suppliers-categories'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;

                    var ind = null;
                    data.forEach((item,i)=> {
                        if(item.name == 'General'){
                            ind = i
                        }
                    })

                    if(ind != null){

                        var obj = data[ind];
                        data.splice(ind, 1);
                        data.unshift(obj);

                    }
                    

                    this.orderData[index].categories = data;


                    return this.orderData;
                }
            });
        },

        getSubCategories(index) {
            return this.$store.dispatch(POST_API, {
                data: {
                    supplier: this.orderData[index].supplier != '' ? this.orderData[index].supplier : null,
                    category: this.orderData[index].category != '' ? this.orderData[index].category : null,
                    site: this.site,
                    item_exist:true,
                },
                api: '/api/all-suppliers-sub-categories'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;
                    
                    if(this.$store.getters.getResults.show_general == true){
                        
                        data.unshift({ _id: "general", name: "General" });

                    }
                    this.orderData[index].sub_categories = data;
                    return this.orderData;
                }
            });
        },
        
        
        calAmount(i,index){
            if (this.invalidQtyKey == i + '_' + index) {
                this.invalidQtyKey = null;
            }

            this.orderData[i].data[index].amount = (this.orderData[i].data[index].unit_price * this.orderData[i].data[index].qty).toFixed(2);

            // console.log(this.orderData[i].data[index].amount);
            // console.log(this.orderData[i].data[index]);
            // console.log(this.orderData[i].data);
            // console.log(this.orderData[i]);

            return this.orderData[i].data[index].amount;
        },
        isQtyInvalid(i, index) {
            return this.invalidQtyKey == i + '_' + index;
        },
        // SweetAlert2 restores focus to whatever was focused when the popup opened
        // (the Submit button) shortly after it closes - a 150ms hide animation plus
        // a further 100ms internal delay - and the browser auto-scrolls that
        // refocused element into view, dragging the page back down over our own
        // scroll. Scrolling immediately and again after that window just produces
        // a visible bounce (field -> button -> field), so instead wait it out and
        // scroll once, after SweetAlert2 is done touching focus/scroll.
        scheduleScrollFix(fn) {
            setTimeout(fn, 400);
        },
        // Mirrors the server-side check in submit-inventory-order: every enabled
        // item must have a qty greater than 0. Runs before the confirm dialog so
        // the user sees the bad field highlighted instead of a generic error.
        validateQuantities() {
            for (let i = 0; i < this.orderData.length; i++) {
                var list = this.orderData[i];

                for (let index = 0; index < list.data.length; index++) {
                    var item = list.data[index];

                    if (item.enabled == 'yes' && (item.qty === '' || Number(item.qty) === 0)) {
                        var supplier = this.suppliers.find(s => s._id == list.supplier);

                        // Don't touch any reactive state (e.g. invalidQtyKey) until the
                        // popup is dismissed - the total-amount cell re-evaluates on every
                        // re-render and calls Swal.close(), which was closing this popup
                        // almost instantly whenever a re-render slipped in before the user
                        // could click OK.
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: item.name + ' quantity must be greater than 0' + (supplier ? ' in ' + supplier.name : ''),
                        }).then(() => {
                            this.invalidQtyKey = i + '_' + index;

                            this.$nextTick(() => {
                                this.scheduleScrollFix(() => this.scrollToInvalidQty(i, index));
                            });
                        });

                        return false;
                    }
                }
            }

            this.invalidQtyKey = null;

            return true;
        },
        scrollToInvalidQty(i, index) {
            var refName = 'qty_' + i + '_' + index;
            var refEl = this.$refs[refName];

            if (Array.isArray(refEl)) {
                refEl = refEl.find(el => el && el.$el && el.$el.offsetParent !== null) || refEl[0];
            }

            if (refEl && refEl.$el) {
                refEl.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                refEl.focus();
            }
        },
        // Mirrors the server-side check in submit-inventory-order: an admin delivering
        // to another site must pick a delivery date.
        validateDeliveryDate() {
            var required = this.$store.getters.currentUser.role == 'admin'
                && this.enable_multiple_supplier_delivery_site == 'yes'
                && (this.deliveryDate === null || this.deliveryDate === '');

            if (!required) {
                return true;
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Delivery date is required.',
            }).then(() => {
                this.invalidDeliveryDate = true;

                this.$nextTick(() => {
                    this.scheduleScrollFix(() => this.scrollToInvalidDeliveryDate());
                });
            });

            return false;
        },
        scrollToInvalidDeliveryDate() {
            var refEl = this.$refs.deliveryDateInput;

            if (refEl && refEl.$el) {
                // Just scroll - don't call .focus() here. Unlike the plain qty <input>,
                // this is a dropdown-based datepicker, and programmatically focusing its
                // toggle button was leaving it unresponsive to clicks for a few seconds
                // afterwards (its popup positioning logic getting in the way). The red
                // border is enough to point the user at it.
                refEl.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
        // Mirrors the server-side check in submit-inventory-order: every delivery
        // row must have a project site selected when delivering to other sites.
        // Runs before confirmSubmit() (the budget-exceeded confirmation) so that
        // dialog is the last gate before actual submission, not the first thing
        // the user sees only to have the server reject it afterwards.
        validateDeliverySites() {
            var role = this.$store.getters.currentUser.role;

            if (this.enable_multiple_supplier_delivery_site != 'yes' || ['supervisor', 'crew'].includes(role)) {
                this.invalidDeliverySiteIndex = null;
                return true;
            }

            for (let ind = 0; ind < this.multiDeliveryData.length; ind++) {
                if (!this.multiDeliveryData[ind].site) {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Please select delivery project site.',
                    }).then(() => {
                        this.invalidDeliverySiteIndex = ind;

                        this.$nextTick(() => {
                            this.scheduleScrollFix(() => this.scrollToInvalidDeliverySite(ind));
                        });
                    });

                    return false;
                }
            }

            this.invalidDeliverySiteIndex = null;

            return true;
        },
        isInvalidDeliverySite(ind) {
            return this.invalidDeliverySiteIndex === ind;
        },
        scrollToInvalidDeliverySite(ind) {
            var item = this.multiDeliveryData[ind];
            var refName;

            if (item.site_source == 'other_area') {
                refName = item.other_area_cluster ? ('otherAreaSite_' + ind) : ('clusterSelect_' + ind);
            } else {
                refName = 'assignedSite_' + ind;
            }

            var refEl = this.$refs[refName];

            if (Array.isArray(refEl)) {
                refEl = refEl[0];
            }

            if (refEl && refEl.$el) {
                // Scroll only - don't call .focus() here. Same reason as the
                // delivery-date field below: programmatically focusing one of
                // these selects right after the scroll was intercepting the next
                // click and routing it to whatever the browser decided to focus/
                // open instead (reported: opened the signature modal). The red
                // border from :state is enough to point the user at it.
                refEl.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
        isNumber($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if (keyCode < 48 || keyCode > 57) {
                $event.preventDefault();
            }
        },
        changetype(e){
            
            if(e == 'monthly'){
                this.month = moment(this.date).add(1,'months').format('MMMM');
                
            }else{
                this.month = moment(this.date).format('MMMM');
                if (parseInt(moment().tz('Asia/Singapore').format('DD')) >= 28) {
                    this.month = moment(this.date).add(1, 'months').format('MMMM');
                }
            }

            if(this.site != ''){
                
                this.getData().then(() => {
                    // console.log('++++11');
                    this.dlSiteChange(this.site, 0);
                });
            }
        },
        updateSubPrice(i){
            var amount = 0;
            
            this.orderData[i].data.forEach(t => {
                amount = parseFloat(amount) + parseFloat(t.amount == '' ? 0 : t.amount);
            })

            return amount.toFixed(2);
        },
        viewSubTotal(){
            var amount = 0;
            this.orderData.forEach(item => {
                
                item.data.forEach(t => {
                    amount = parseFloat(amount) + parseFloat(t.amount == '' ? 0 : t.amount);
                })

            })

            return amount.toFixed(2);
        },
        
        viewDeliveryTotal(){
            var amount = 0;
            var del_amount = 0;
            this.orderData.forEach(item => {

                item.data.forEach(t => {
                    amount = parseFloat(amount) + parseFloat(t.amount == '' ? 0 : t.amount);
                })

                if(!(item.fee_weiver == 'yes' && Number(amount) >= Number(item.moq)) && this.enable_multiple_supplier_delivery_site == 'yes' && (!item.delivery_fee_removed || item.delivery_fee_removed=='no')){
                    del_amount = parseFloat(del_amount) + parseFloat(item.delivery_fee == '' ? 0 : item.delivery_fee); 
                }

            })

            return del_amount.toFixed(2);
        },
        viewDeliveryTotal2(){
            var deli_amount = 0;
            for(let i = 0; i<this.orderData.length; i++){
                if(!this.orderData[i].delivery_fee_removed || this.orderData[i].delivery_fee_removed == 'no'){
                    deli_amount += this.deli_fee_moq[i.toString()];
                }
            }
            return deli_amount.toFixed(2);
        },
        addDLMore(){
            this.deliveryData.push({
                site: '',
                site_name: '',
                address: '',
                lat: '',
                long: '',
                supervisors:[],
                operational_managers:[],
                country: null,
                _showDetails: false,
                site_source: 'assigned',
                other_area_cluster: '',
                other_area_sites: [],
                _from_db: false
            })
        },
        
        removeDeliveryItem(i){
            this.deliveryData.splice(i,1);

            if(this.deliveryData.length == 0){
                this.addDLMore();
            }
        },
        checkdisabled() {
            if (this.ledit == true) {
                return false;
            } else if (this.disabledOptions == true) {
                return true;
            } else {
                return false;
            }
        },
        checkDisabled(id){
            var allIds = this.deliveryData.map(item => {return item.site});
            return allIds.includes(id)
            
        },
        dlSiteChange(id,i){
            
            var site = this.sites.find(item => item._id == id);
            this.deliveryData[i].site_name  = site.site_name;
            this.deliveryData[i].site       = site._id;
            this.deliveryData[i].address    = site.address;
            this.deliveryData[i].lat        = site.lat;
            this.deliveryData[i].long       = site.long;
            
            this.deliveryData[i].country = site.country;

            return this.$store.dispatch(POST_API, {
                data: {
                    site: id,
                },
                api: '/api/site-area-user-info'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data;
                    this.deliveryData[i].user = data.length > 0 ? data[0].user : null;
                    //console.log(data);
                }
            });





            return this.deliveryData;
        }, 
        
        goBack() {

            var msg = 'Do you want to Go back without saving your report?';

            this.decisionAlert(msg)
                .then(result => {
                    if (result.value) {
                        localStorage.setItem('routeCFCheck', 'no');
                        
                        this.$router.push({ name: 'inventory-order' })


                    }
                })
        },
        async formSubmit(e) {
            e.preventDefault();

            // SweetAlert2 refocuses whatever element was focused when a popup opened
            // (usually this Submit button) ~100ms after it closes, and the browser
            // auto-scrolls a newly-focused element into view. That was dragging the
            // page back down to the button right after we'd scrolled up to a bad
            // field. Blurring it first means SweetAlert2 has nothing of ours to
            // refocus, so our scroll position sticks.
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }

            if(await this.checkMonthlyReportCount2() && this.original_status != 'draft' && this.id == null && this.order_type == 'monthly'){
                this.customAlert('', 'Inventory Order Already Exists for this month.', 'info')
            } else {
                var roles = ['administrator', 'admin', 'senior_operation_manager', 'operation_manager', 'operation_executive', 'site_client', 'site_manager', 'crew'];

                if(roles.includes(this.$store.getters.currentUser.role) == false && this.orderCount > 0 && this.order_type == 'monthly'){
                    this.customAlert('', 'Inventory Order Already Exists for this month.', 'info')
                } else {
                    if (this.status == 'draft') {
                        this.actualForm();
                    } else if (!this.validateQuantities()) {
                        this.revertDraftStatus();
                    } else if (!this.validateDeliveryDate()) {
                        this.revertDraftStatus();
                    } else if (!this.validateDeliverySites()) {
                        this.revertDraftStatus();
                    } else {
                        this.confirmSubmit()
                        .then(result => {
                            if (result.value) {
                                this.actualForm();
                            } else {
                                this.revertDraftStatus();
                            }
                        })
                    }
                }
            }
        },
        revertDraftStatus() {
            if (this.original_status == 'draft') {
                this.status = 'draft';
            }
        },
        // When the order is over budget, ask a budget-specific confirmation instead
        // of the generic one. budget_class is a computed derived from orderTotalAmount,
        // so reading it here doesn't re-trigger the "Total Amount Exceeding..." toast.
        confirmSubmit() {
            if (this.budget_class == 'text-danger') {
                return Swal.fire({
                    title: 'Please Confirm',
                    html: 'Are you sure you want to submit this report despite <span style="color:#dc3545;font-weight:600;">Total Amount Exceeding Allocated Budget</span>?',
                    icon: 'warning',
                    position: 'center',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                });
            }

            return this.decisionAlert('Are you sure you want to submit this report?');
        },
        handleHiddenDeliveryData() {
            return new Promise((resolve) => {

                for (let i = 0; i < this.multiDeliveryData.length; i++) {
                    this.multiDeliveryData[i].address = this.deliveryData[0].address;
                    this.multiDeliveryData[i].country = this.deliveryData[0].country;
                    this.multiDeliveryData[i].lat = this.deliveryData[0].lat;
                    this.multiDeliveryData[i].long = this.deliveryData[0].long;
                    this.multiDeliveryData[i].site = this.deliveryData[0].site;
                    this.multiDeliveryData[i].site_name = this.deliveryData[0].site_name;
                    this.multiDeliveryData[i].user = this.deliveryData[0].user;
                    if(i == this.multiDeliveryData.length - 1){
                        resolve(true)
                    }
                }
            })
        },
        async actualForm(){
            var orderData = this.orderData.map(({ filter_items, ...rest }) => rest);

            var final_orderData = orderData.map(item => ({
                ...item,
                data: item.data.map(({ matched, ...rest }) => rest),
            }));
            
            if(this.$store.getters.currentUser.role == 'supervisor'){
                // console.log(true)
                await this.handleHiddenDeliveryData();
            }

            return this.$store.dispatch(POST_API, {
                data: {
                    id: this.id,
                    site: this.site,
                    order_type: this.order_type,
                    date: this.date,
                    deliveryDate: this.deliveryDate,
                    month: this.month,
                    order_by: this.order_by,
                    orderData: final_orderData,
                    special_requisition: this.special_requisition,
                    deliveryData : this.deliveryData,
                    multiple_delivery_option : this.multiple_delivery_option,
                    signature: this.signature,
                    status: this.status,
                    form_id: this.$route.params.id,
                    role: this.$store.getters.currentUser.role,
                    approve_signature: this.supervisorSign,
                    approve_signature_time: this.approve_signature_time,
                    approve_remark: this.approve_remark,
                    total_amount: this.viewSubTotal(),
                    enable_multiple_supplier_delivery_site: this.enable_multiple_supplier_delivery_site,
                    multiDeliveryData: this.multiDeliveryData,
                    validation_record: this.validation_record
                },
                api: '/api/update-inventory-order'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    if(this.status != 'approved' && typeof this.$route.params.id == 'undefined'){
                        this.status = 'draft';
                    }
                    this.errorAlertCF()
                } else {
                    this.showDismissibleAlert = false;

                    var data = this.$store.getters.getResults.data;

                    this.successAlert().then((result) => {

                        if (this.sites.length == 1) {
                            this.site = this.sites[0]._id;
                        } else {
                            this.site = '';
                        }
                        this.siteChange();

                        if (data != null) {
                            window.open(data, '_blank');
                        }
                        localStorage.setItem('routeCFCheck', 'no');

                        Bus.$emit('counter_update');
                        
                        this.$router.push({ name: 'inventory-order' });
                    });
                }
            });


        },
        checkUnique(i) {
            var arr = [];
            var flag = false;

            for(var i=0;i < this.orderData.length ; i++){

                var item = this.orderData[i];
                
                if (arr.indexOf(item.supplier + item.category + item.sub_category) >= 0) {
                    this.customAlert('Supplier Items Category Information already Exists.', '', 'warning');

                    this.orderData[i].sub_category = '';
                    this.orderData[i].data = [];
                    flag =true;

                    i = this.orderData.length;
                } else {
                    arr.push(item.supplier + item.category + item.sub_category);
                }

            }

            return flag;

            this.orderData.forEach((item) => {
                
            })

            return false;
        },
        updateSupplierData(index, item) {
            // console.log(index,item);
            return this.$store.dispatch(POST_API, {
                data: {
                    site     : this.site,
                    supplier : item.supplier,
                },
                api: "/api/fetch-latest-supplier-items",
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showAlert();
                } else {
                    let data = this.$store.getters.getResults.data;
                    
                    const existingIds = item.data.map(item => item._id);

                    var i = item.data.length + 1;

                    data.forEach(el => {
                        if (!existingIds.includes(el._id)) {
                            item.data.push({
                                '_id': el._id,
                                'code': el.code,
                                'name': el.name,
                                'category': el.category,
                                'sub_category': el.sub_category,
                                'packing': el.packing,
                                'unit_price': el.unit_price,
                                'enabled': 'no',
                                'amount': '',
                                'bal': 0,
                                'qty': 0,
                                'most_order': 'no',
                                'order': i,
                                'matched': true
                            })

                            i++;
                        }
                    });
                }
            });
        },
        removeDBData(index, item) {
            //console.log(index,item);

            var msg = 'Are you sure you want to remove this Supplier Items record?';

            this.decisionAlert(msg)
            .then(result => {
                if (result.value) {
                    return this.$store.dispatch(POST_API, {
                        data: {
                            supplier: item.supplier,
                            id: this.id,
                        },
                        api: "/api/remove-inventory-order-db-supplier",
                    })
                        .then(() => {
                            if (this.$store.getters.containsErrors) {
                                this.error_message = this.$store.getters.getErrors;

                                this.showAlert();
                            } else {
                                //localStorage.setItem('routeCFCheck','no');
                                this.successAlert()
                                    .then(() => {

                                        this.orderData.splice(index, 1);
                                        if (this.orderData.length == 0) {
                                            this.addMore();
                                        }

                                        this.multiDeliveryData.splice(index, 1);
                                        if (this.multiDeliveryData.length == 0) {
                                            this.multiDeliveryData.push({
                                                order: '',
                                                supplier_name: '',
                                                supplier_id: '',
                                                site: '',
                                                site_name: '',
                                                address: '',
                                                lat: '',
                                                long: '',
                                                supervisors: [],
                                                operational_managers: [],
                                                country: null,
                                                _showDetails: false,
                                                site_source: 'assigned',
                                                other_area_cluster: '',
                                                other_area_sites: [],
                                                _from_db: false
                                            });
                                        }

                                    });
                            }
                        });
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        
        discardItem(id) {
            var msg = 'Are you sure you want to discard this record?';

            this.decisionAlert(msg)
            .then(result => {
                if (result.value) {
                    return this.$store.dispatch(POST_API, {
                        data: {
                            id: id,
                            status: 'deleted'
                        },
                        api: "/api/change-status-inventory-order-report-data",
                    })
                        .then(() => {
                            if (this.$store.getters.containsErrors) {
                                this.error_message = this.$store.getters.getErrors;

                                this.showAlert();
                            } else {
                                localStorage.setItem('routeCFCheck', 'no');
                                this.successAlert()
                                    .then(() => {
                                        
                                        this.$router.push({ name: 'inventory-order' })
                                    });
                            }
                        });
                }
            })
            .catch(err => {
                console.log(err);
            })
        }, 
        disabledDate(date) {
            return date < moment(new Date(this.date)).subtract(1, 'days').tz('Asia/Singapore');
        },
        getFormDetails() {
            /*localStorage.setItem('routeCFCheck','yes');*/

            return this.$store.dispatch(POST_API, {
                data: {
                    id: this.$route.params.id
                },
                api: '/api/get-inventory-order-report-detail-for-update'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showDismissibleAlert = true;
                        window.scrollTo(0, 0);
                    } else {
                        this.showDismissibleAlert = false;
                        var data = this.$store.getters.getResults.data;

                        this.original_suppliers = this.$store.getters.getResults.supplier_ids;

                        this.id = data._id;
                        this.date = data.date;
                        this.deliveryDate = data.deliveryDate;
                        this.site = data.site;
                        this.loadDeliveryAreaContext();
                        this.order_by = data.order_by;
                        this.month = data.month;
                        this.order_type = data.order_type;
                        
                        this.orderData = data.orderData;
                        this.status = data.status;
                        this.original_status = data.status;

                        this.signature = {
                            image: data.signature,
                            name: 'signature.png',
                            type: 'supervisor',
                            default: 'yes'
                        };
                        this.special_requisition = data.special_requisition;

                        if(this.special_requisition.length > 0){
                            this.customAlert('', 'There is Special Requisition. Please Acknowledge.', 'info')
                        }

                        this.multiple_delivery_option = data.delivery_option;
                        this.deliveryData = data.deliveryData;

                        this.flag_data = true;

                        this.enable_multiple_supplier_delivery_site = data.enable_multiple_supplier_delivery_site;
                        this.multiDeliveryData = data.multiDeliveryData;
                        this.hydrateDeliveryRowSources();

                        this.validation_record = (data.validation_record !== null && data.validation_record !== undefined) ? data.validation_record : [];
                        
                        this.validator_status = data.level_user_status;

                        var role = this.$store.getters.currentUser.role;

                        if (data.reject_to == role && ((data.level_one_user_role != role) && (data.level_two_user_role != role) && (data.level_three_user_role != role))) {
                            //this.disabledOptions = false;
                            this.ledit = true;
                        } 

                        this.allSuppliers();
                    }
                });

        },
        showNumberFormat(phone_number,country) {
            //console.log(phone_number,country);
            var prefix = '';
            if(country == 'Singapore'){
                prefix = '+65';
            }else{
                prefix = '+66';
            }
            
            if(phone_number.length == 8){
                
                return prefix + ' ' + phone_number.replace(/(\d{4})(\d{4})/, "$1 $2");
            }else{
                return prefix + ' ' + phone_number;
            }
            
        },
        getAllSuppliersItem(supplier,index){
             return this.$store.dispatch(POST_API, {
                data: {
                    supplier: supplier,
                    site:this.site,
                    order_type: this.order_type
                },
                api: '/api/get-all-supplier-items'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0, 0);
                } else {
                    this.showDismissibleAlert = false;
                    var data = this.$store.getters.getResults.data.map(dataObj => ({ ...dataObj, matched: true }))

                    this.orderData[index].data = data;
                    if(data.length > 0){
                        this.orderData[index].fee_weiver = data[0].fee_weiver;
                    }
                    //console.log(data);
                }
            });
        },
        supplierDisable(id) {
            var sup_ids = [];
            for (var i = 0; i < this.orderData.length; i++) {
                if (this.orderData[i].supplier != '') {
                    sup_ids.push(this.orderData[i].supplier);
                }
            }


            if (sup_ids.indexOf(id) >= 0) {
                return true;
            } else {
                return false;
            }

        },

        siteDisable(id) {
            var site_ids = [];
            for (var i = 0; i < this.deliveryData.length; i++) {
                site_ids.push(this.deliveryData[i].site);
            }


            if (site_ids.indexOf(id) >= 0) {
                return true;
            } else {
                return false;
            }

        },
        resetFilter(i){
            this.orderData[i].category = '';
            this.orderData[i].sub_category = '';
            this.orderData[i].sub_categories = [];

            this.orderData[i].data = this.orderData[i].data.map(dataObj => ({ ...dataObj, matched: true }));

            // this.orderData = data.orderData.map(obj => ({
            //     ...obj,
            //     data: obj.data.map(dataObj => ({ ...dataObj, matched: true }))
            // }));
            // this.orderData[i].filter_items = '';
        },
        updateItemValue(i,index){
            //this.orderData[i].data[index].enabled
            if(this.orderData[i].data[index].enabled == 'no'){
                this.orderData[i].data[index].qty = '0';
                this.orderData[i].data[index].amount = '';
                this.orderData[i].data[index].bal = '0';

            }
        },

        checkMonthlyReportCount(){
            return this.$store.dispatch(POST_API, {
            data: {
                role: this.$store.getters.currentUser.role,
                site: this.site != '' ? this.site : null,
            },
            api: '/api/check-inventory-order-monthly-count'
            })
            .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                this.showDismissibleAlert = true;
            } else {
                var roles = ['administrator', 'admin', 'senior_operation_manager', 'operation_manager', 'operation_executive', 'site_client', 'site_manager', 'crew'];
                if(this.$store.getters.getResults.data > 0 && roles.includes(this.$store.getters.currentUser.role)){
                    this.checkOrderCount = false;
                    this.orderCount = this.$store.getters.getResults.data;
                } else {
                    this.checkOrderCount = true;
                    this.orderCount = this.$store.getters.getResults.data;
                }

            }
            });
        },
        checkMonthlyReportCount2(){
            return this.$store.dispatch(POST_API, {
            data: {
                role: this.$store.getters.currentUser.role,
                site: this.site != '' ? this.site : null,
            },
            api: '/api/check-inventory-order-monthly-count'
            })
            .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                this.showDismissibleAlert = true;
            } else {
                // console.log(this.$store.getters.getResults.data)
                if(this.$store.getters.getResults.data > 0 && this.order_type == 'monthly'){
                    return true
                } else{
                    return false
                }
            }
            });
        },        
        isDouble($event){
            let keyCode = ($event.which ? $event.which : $event.keyCode);
            console.log(keyCode)
            if ((keyCode < 48  && keyCode != 46) || keyCode > 57) {
                    $event.preventDefault();
            }
        },
        checkMoq(subtotal, index, order_data) {
            if (order_data.delivery_fee_removed && order_data.delivery_fee_removed == 'yes') {
                this.deli_fee_moq[index.toString()] = 0;
                return
            }
            return this.$store.dispatch(POST_API, {
                data: {
                    site: this.site,
                    order_data: order_data,
                    subtotal: subtotal,
                    delivery_data: this.multiDeliveryData[index],
                    deliveryDate: this.deliveryDate,
                    month: this.month,
                },
                api: '/api/inventory-check-moq'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showDismissibleAlert = true;
                    } else {
                        this.deli_fee_moq[index.toString()] = this.$store.getters.getResults.data;
                        this.resetFilter(index);
                    }
                });
        },
    },
    mounted() {
        //this.createAuditMonth();
        this.useDefault();
        this.allSites();
        // this.checkMonthlyReportCount();        

        if (this.$route.params.id) {
            this.disabledOptions = true;
            this.checkOrderCount = true;
            this.getFormDetails().then(() => {
                this.orderData.forEach((item, index) => {
                    if(this.deliveryDate != null){
                        this.checkMoq(this.updateSubPrice(index), index, item);
                    }
                    this.resetFilter(index);
                });
            });
        }

        if((this.role == 'director' || this.role == 'senior_operation_manager' || this.role == 'operation_manager' || this.role == 'admin') && this.$route.params.id){
            this.show_all_items = false;
        }
        if(parseInt(moment().tz('Asia/Singapore').format('DD')) >= 28){
            this.month = moment().tz('Asia/Singapore').add(1, "months").format('MMMM')
        }
    }
}
</script>

<style scoped>
.form-inline .custom-control-label {
    margin-bottom: 0;
    font-weight: normal;
    margin-top: 2px;
    text-transform: capitalize;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
